module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "ch01"
    }
  }, [_c('h1', {
    staticClass: "cn"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "p15"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chikervegan0005#rch01"
    }
  }, [_c('span', {
    staticClass: "symb"
  }, [_vm._v("•")]), _vm._v(" 1 "), _c('span', {
    staticClass: "symb"
  }, [_vm._v("•")])])]), _vm._v(" "), _c('h1', {
    staticClass: "ct"
  }, [_vm._v("Law")]), _vm._v(" "), _c('h1', {
    staticClass: "cs"
  }, [_vm._v("Its Concept and Actualizations")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_vm._v("There is one point on which, with few exceptions, partisans, adversaries, casual readers, and recognized specialists of Hegel have all agreed: Hegel’s philosophy does not look favorably on the notion of law. Thus, an established specialist writes, “Law is not Hegel’s God . . . Hegel hardly prizes law or freedom of the person.”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn131",
      "id": "fn131r"
    }
  }, [_vm._v("1")]), _vm._v(" Indeed, doesn’t Hegel constantly describe law—at least, the law he calls “limited juristic law”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn132",
      "id": "fn132r"
    }
  }, [_vm._v("2")]), _vm._v("—as formal and abstract?"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn133",
      "id": "fn133r"
    }
  }, [_vm._v("3")]), _vm._v(" And doesn’t the "), _c('i', [_vm._v("Phenomenology of Spirit")]), _vm._v(", as well as the "), _c('i', [_vm._v("Lectures on the Philosophy of History")]), _vm._v(" (in the section on the Roman world), paint a merciless picture of the state of law or legal status ("), _c('i', [_vm._v("Rechtzustand")]), _vm._v(")?"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn134",
      "id": "fn134r"
    }
  }, [_vm._v("4")]), _vm._v(" And isn’t it necessary to go beyond the sphere of abstract law in order to arrive at the essential truth of the human world, which is an ethical-"), _c('i', [_vm._v("political")]), _vm._v(" truth? From this point of view, law in the strict sense—which in Kantian practical philosophy is foundational and, in a "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p16"
    }
  }), _vm._v("way, insurmountable: "), _c('i', [_vm._v("fiat justitia, pereat mundus")]), _vm._v(" (let there be justice, though the world perish)"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn135",
      "id": "fn135r"
    }
  }, [_vm._v("5")]), _vm._v("—seems instead like a bad moment to be passed through. Of course, in 1820, when Hegel published an amply fleshed-out version of the part of the system that, since the first 1817 edition, the "), _c('i', [_vm._v("Encyclopedia")]), _vm._v(" had somewhat esoterically termed "), _c('i', [_vm._v("objective spirit")]), _vm._v(","), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn136",
      "id": "fn136r"
    }
  }, [_vm._v("6")]), _vm._v(" Hegel titled the version "), _c('i', [_vm._v("Elements of the Philosophy of Right")]), _vm._v("—a remarkable expression, all the more remarkable as it was unusual at the time. But this innovation, which was actually offset by a more classical subtitle—"), _c('i', [_vm._v("Naturrecht und Staatswissenschaft")]), _vm._v(" (Natural law and the science of the state)—seems above all intended to relativize law by grounding it in an extralegal—even antilegal—context of which the state, which Hegel thinks should be “venerate[d] as an earthly divinity,”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn137",
      "id": "fn137r"
    }
  }, [_vm._v("7")]), _vm._v(" is the determining element. In the assertion that each stratum of objective spirit (law, morality, family, civil society, state, history) features as a “stage in the development of the Idea of freedom” and has “its distinctive right”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn138",
      "id": "fn138r"
    }
  }, [_vm._v("8")]), _vm._v(" is the germ of the subordination of formal law, which becomes no more than a “subordinate moment” of this “altogether different sphere”: the state, sole authentic bearer of “actual and concrete spirit.”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn139",
      "id": "fn139r"
    }
  }, [_vm._v("9")]), _vm._v(" Since the second half of the nineteenth century, this antilegalism and even contempt for law, which so sharply distinguishes Hegel from Kant—for whom “politics must always bend a knee”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn140",
      "id": "fn140r"
    }
  }, [_vm._v("10")]), _vm._v(" to "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p17"
    }
  }), _vm._v("law—has found a convenient explanation with several variants."), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn141",
      "id": "fn141r"
    }
  }, [_vm._v("11")]), _vm._v(" These run as follows: Hegel, a contemporary of the first theoreticians of the "), _c('i', [_vm._v("Rechtstaat")]), _vm._v(" (Robert von Mohl, Rudolf von Gneist, Lorenz von Stein) was, in fact, the precursor of ideologues of the "), _c('i', [_vm._v("Machtstaat.")]), _vm._v(" This, at least, was the image of him held by sycophants and detractors of state power alike, and shared by a large audience: Hegel as an enemy avant la lettre of the envelopment of the state by law, which is, it seems, characteristic of modern democracy. Since then, Hegel studies have convincingly shown that lumping Hegel in with the doctrinaires of "), _c('i', [_vm._v("Realpolitik")]), _vm._v(" and imperialism was overly hasty."), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn142",
      "id": "fn142r"
    }
  }, [_vm._v("12")]), _vm._v(" For many, however, it remains the case that he contributed to the “myth of the state,” of which contemporary totalitarianism marks the ultimate development. If, as Cassirer says, Hegel contributed to this myth “more than any other philosophical system,”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn143",
      "id": "fn143r"
    }
  }, [_vm._v("13")]), _vm._v(" this was through the simultaneous exaltation of politics and devalorization of law that marked his thought. Therefore, it is not surprising that the “return of law” we have witnessed over the past few years in the French philosophical scene has often targeted Hegel and his Marxist legacy.")]), _vm._v(" "), _c('p', [_vm._v("The argument I have just summarized cannot be brushed aside: it would be unreasonable to contest the existence of Hegelian antilegalism. But it is possible to understand “antilegalism” in a variety of ways. For the sake of simplicity, let us focus on two quite distinct attitudes that term may designate: first, a hostility to law and rights that goes along with doubt about their capacity to form a specific order, and second, a hostility to legalism—that is, "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p18"
    }
  }), _vm._v("to the absolutization of law as such. There are good arguments to be made that Hegel, at least in his mature writings, adopts the second attitude and professes what we might call a "), _c('i', [_vm._v("weak antilegalism")]), _vm._v("."), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn144",
      "id": "fn144r"
    }
  }, [_vm._v("14")]), _vm._v(" From this perspective, it can be shown that Hegel both affirms the full autonomy of what he calls abstract law and judges necessary its relativization by the state, which is itself irreducible to any legal model. As we shall see, it is possible to understand that there is no contradiction between these two assertions only on the basis of a conception of civil society as the authentic, though conflictual, realization of the principles of the abstract legal order. But before anything else, it is important to assess the recasting of the classic concept of law performed by Hegel’s thought. Only this will allow us to understand why, while proclaiming the limits of “narrow legal law,” Hegel can at the same time emphatically maintain that law is “something "), _c('i', [_vm._v("utterly sacred")]), _vm._v(", for the simple reason that it is the existence ["), _c('i', [_vm._v("Dasein")]), _vm._v("] of the absolute concept, of self-conscious freedom.”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn145",
      "id": "fn145r"
    }
  }, [_vm._v("15")])]), _vm._v(" "), _c('h2', {
    staticClass: "ah",
    attrs: {
      "id": "ah0201"
    }
  }, [_vm._v("The “Philosophical Science of Law”: Concept and Idea")]), _vm._v(" "), _c('div', {
    staticClass: "epigraph"
  }, [_c('p', {
    staticClass: "epaft"
  }, [_vm._v("The subject-matter of "), _c('i', [_vm._v("the philosophical science of law")]), _vm._v(" is the "), _c('i', [_vm._v("Idea of right")]), _vm._v("—the concept of law and its actualization."), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn146",
      "id": "fn146r"
    }
  }, [_vm._v("16")])])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("This preliminary definition of the philosophy of law is based on the distinction between concept ("), _c('i', [_vm._v("Begriff")]), _vm._v(") and idea ("), _c('i', [_vm._v("Idee")]), _vm._v("). The latter adds to the former (which Hegel sometimes calls “the simple concept,” the “concept as such,” or the “concept of the concept”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn147",
      "id": "fn147r"
    }
  }, [_vm._v("17")]), _vm._v(" in order to distinguish it from the completed, fully developed concept) the dimension of realization or actualization. This "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p19"
    }
  }), _vm._v("distinction is presented and grounded in the "), _c('i', [_vm._v("Logic")]), _vm._v(", as is the key notion of "), _c('i', [_vm._v("Verwirklichung")]), _vm._v(" (actualization) on which it relies.")]), _vm._v(" "), _c('p', [_vm._v("The concept in the Hegelian sense is not to be understood as a general representation developed by a thinking subject, although it does immediately suggest this mangled and provisory meaning:")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "bqs"
  }, [_vm._v("The shape of the "), _c('i', [_vm._v("immediate")]), _vm._v(" concept constitutes the standpoint that makes of the concept a subjective thinking, a reflection external to the "), _c('i', [_vm._v("subject matter")]), _vm._v(". This stage constitutes, therefore, "), _c('i', [_vm._v("subjectivity")]), _vm._v(", or the "), _c('i', [_vm._v("formal concept")]), _vm._v("."), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn148",
      "id": "fn148r"
    }
  }, [_vm._v("18")])])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("In its full meaning—that is, as it is constituted through the process that connects the three moments of the “subjective concept” (the concept as such, judgment, and syllogism)—the concept is thought itself as subject, actor, and prime mover of its development. It refers to thought’s capacity to self-posit or self-produce, an autoaffection (to use Fichtean terminology) to which subjective thought, in the common sense of the term—for example, the philosopher’s thought—is, so to speak, merely a spectator. The true subject of the concept, in the various senses of the term, is not a finite consciousness but rather the real in its totality, expressed in and through the concept and its fundamental articulations, which are (plural) determined concepts. Hence, “the logical forms of the concept” are not “dead . . . receptacles of representations,” which would make them the objects of “a completely superfluous and dispensable "), _c('i', [_vm._v("description")]), _vm._v("”; instead, they are “"), _c('i', [_vm._v("the living spirit of what is actual")]), _vm._v(",”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn149",
      "id": "fn149r"
    }
  }, [_vm._v("19")]), _vm._v(" the soul of the real. Thus, the subjective concept has a "), _c('i', [_vm._v("necessary")]), _vm._v(" relation to objectivity, a relation far more complex than that between empty form and inert content. Objectivity is not a given, closed world that faces the thinking subject; it is rather “the "), _c('i', [_vm._v("real concept")]), _vm._v(" that "), _c('i', [_vm._v("has emerged from its inwardness")]), _vm._v(" and has passed over into existence.”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn150",
      "id": "fn150r"
    }
  }, [_vm._v("20")]), _vm._v(" As Hegel understands it, objectivity is the realization of the concept in exteriority, “immediacy as which the concept has determined itself by the sublation of its abstraction and mediation”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn151",
      "id": "fn151r"
    }
  }, [_vm._v("21")]), _vm._v(" such that the pulse of the concept, which is the soul of objectivity, seems to have "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p20"
    }
  }), _vm._v("disappeared within it; in reality, however, it is only the appearance of the exteriority of subjective thought with respect to the objective real that vanishes. According to the "), _c('i', [_vm._v("Logic")]), _vm._v(", objectification is the decisive act by which the concept, going beyond the interiority of a privileged relationship to itself, verifies its ability to organize the objectivity of things and is experienced as an immanent structuring of the world. We must still analyze the unity of the subjective and the objective that is first given in an immediate—and thus external—manner. In the sense of speculative logic, the idea, the “subject-object,”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn152",
      "id": "fn152r"
    }
  }, [_vm._v("22")]), _vm._v(" is the "), _c('i', [_vm._v("process")]), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn153",
      "id": "fn153r"
    }
  }, [_vm._v("23")]), _vm._v(" that dialectically unifies the subjective concept and objectivity without destroying their difference. Thus, the idea, in its mobility and inexhaustible vitality, is “"), _c('i', [_vm._v("the adequate")]), _vm._v(" concept, the objectively "), _c('i', [_vm._v("true")]), _vm._v(", or "), _c('i', [_vm._v("the true as such")]), _vm._v(".”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn154",
      "id": "fn154r"
    }
  }, [_vm._v("24")]), _vm._v(" In the Hegelian sense, an idea is entirely different from a “simple idea,” if by that is meant a subjective representation devoid of any content of reality. Instead, it expresses the rational texture of the real (of objectivity), "), _c('i', [_vm._v("its")]), _vm._v(" thought "), _c('i', [_vm._v("of itself")]), _vm._v(", “for the externality has being only as determined by the concept and as taken up into its negativity.”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn155",
      "id": "fn155r"
    }
  }, [_vm._v("25")]), _vm._v(" In the Hegelian sense, the idea is reason—but reason incorporated into materiality."), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn156",
      "id": "fn156r"
    }
  }, [_vm._v("26")]), _vm._v(" This reason thus no longer has anything to do with some subjective faculty or anthropological determination; in Hegel, reason is the philosophical name for the process by which subjectivity and objectivity, thought and worldly reality, infinitely overlap without ever being completely identical, which would be the death of all thought."), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn157",
      "id": "fn157r"
    }
  }, [_vm._v("27")]), _vm._v(" Thus, the idealism that Hegel claims (and doesn’t he assert that “every genuine philosophy is "), _c('i', [_vm._v("Idealism")]), _vm._v("”?"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn158",
      "id": "fn158r"
    }
  }, [_vm._v("28")]), _vm._v(") comes down to this fundamental, two-part thesis: all reality, or rather actuality, is conceptual, and there is no concept that is not objectivized in the human and natural world. Above, I analyzed the meaning and consequences"), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p21"
    }
  }), _vm._v(" of such a definition: we know that it expresses the conviction—which is ultimately a metaphysical and speculative conviction—that there is a fundamental coherence between the rational and the actual, between “reason that is conscious of itself” and “reason that "), _c('i', [_vm._v("is")]), _vm._v(".”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn159",
      "id": "fn159r"
    }
  }, [_vm._v("29")]), _vm._v(" We must now specify the consequences of this for the conceptualization of law.")]), _vm._v(" "), _c('p', [_vm._v("How can the above account of the logic of the concept help us understand the status of what Hegel calls the philosophical science of law and decode its definition in the "), _c('i', [_vm._v("Philosophy of Right")]), _vm._v("? First of all, it allows us to give specific content to the distinction between the concept and idea of law, which Hegel describes in section 2 of the introduction:")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "bqs"
  }, [_vm._v("The science of law is "), _c('i', [_vm._v("a part of philosophy")]), _vm._v(". It has therefore to develop the "), _c('i', [_vm._v("Idea")]), _vm._v(", which is the reason within an object ["), _c('i', [_vm._v("Gegenstand")]), _vm._v("], out of the concept; or what comes to the same thing, it must observe the proper immanent development of the thing ["), _c('i', [_vm._v("Sache")]), _vm._v("] itself. As a part [of philosophy], it has a determinate "), _c('i', [_vm._v("starting point")]), _vm._v(", which is the "), _c('i', [_vm._v("result")]), _vm._v(" and truth of what "), _c('i', [_vm._v("preceded")]), _vm._v(" it, and what preceded it is the so-called "), _c('i', [_vm._v("proof")]), _vm._v(" of that result. Hence the concept of law, so far as its "), _c('i', [_vm._v("coming into being")]), _vm._v(" is concerned, falls outside the science of law; its deduction is presupposed here and is to be taken as "), _c('i', [_vm._v("given")]), _vm._v("."), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn160",
      "id": "fn160r"
    }
  }, [_vm._v("30")])])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("We must first understand why Hegel writes that “the concept of law falls outside the science of law”—quite a surprising statement on the face of it. To do so, we must be attentive to the distinction between concept and idea. If for Hegel law is “freedom, as Idea,”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn161",
      "id": "fn161r"
    }
  }, [_vm._v("31")]), _vm._v(" this is because law participates in the objectivization of a principle that is initially subjective or inner—that is, freedom—which is the defining feature of spirit, or, to use a later term, of “"), _c('i', [_vm._v("culture")]), _vm._v(",” as distinct from “nature” and the universe of necessity, while also being essentially connected to it. Freedom is thus the "), _c('i', [_vm._v("concept")]), _vm._v(" that becomes objective via the successive strata of objective spirit, unfolding itself in the "), _c('i', [_vm._v("idea")]), _vm._v(" that is, in the totality of its determinations, the idea of the law. By thus defining the object of the "), _c('i', [_vm._v("philosophical")]), _vm._v(" science of law—in truth, for Hegel, there is no philosophy that is not scientific"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn162",
      "id": "fn162r"
    }
  }, [_vm._v("32")]), _vm._v("—he is emphasizing that law is wholly of the order of an "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p22"
    }
  }), _vm._v("objectivization of what is initially a (merely) subjective principle, its “simple concept.” This concept itself is the culmination of the process of subjective spirit,"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn163",
      "id": "fn163r"
    }
  }, [_vm._v("33")]), _vm._v(" a process thus akin to the philosophical deduction of law and rights. This is indeed why paragraphs 5 through 28 of the introduction to the "), _c('i', [_vm._v("Philosophy of Right")]), _vm._v(" recapitulate the final steps of this process."), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn164",
      "id": "fn164r"
    }
  }, [_vm._v("34")]), _vm._v(" The entire sphere of objective spirit (i.e., of law in the broad sense) bears the mark of this first determination. The movement included in this sphere—a movement whose phases are like the strata of the "), _c('i', [_vm._v("idea")]), _vm._v(" of law—is actually the negative rejoinder to the movement of subjective spirit. Whereas subjective spirit conquers its own determination (freedom) against the naturalness that initially subsumed it (under the figure of the soul), law starts off from freedom in order to constitute it as second nature. This nature is "), _c('i', [_vm._v("essentially")]), _vm._v(" second, since it presupposes the spirit whose concept it makes objective, and thus it is fundamentally different from “first” nature because the objective world it constitutes is “produced and to be produced” by spirit."), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn165",
      "id": "fn165r"
    }
  }, [_vm._v("35")]), _vm._v(" If spirit is higher than nature,"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn166",
      "id": "fn166r"
    }
  }, [_vm._v("36")]), _vm._v(" this is precisely due to its ability and vocation to reproduce in itself and from itself as a veritable nature "), _c('i', [_vm._v("of")]), _vm._v(" spirit, the nature of which it is initially, abstractly, only simple negation or going-beyond:")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "bqs"
  }, [_vm._v("The basis ["), _c('i', [_vm._v("Boden")]), _vm._v("] of law is the "), _c('i', [_vm._v("realm of spirit")]), _vm._v(" in general and its precise location and point of departure is the "), _c('i', [_vm._v("will")]), _vm._v("; the will is "), _c('i', [_vm._v("free")]), _vm._v(", so that freedom constitutes its substance and destiny ["), _c('i', [_vm._v("Bestimmung")]), _vm._v("] and the system of law is the realm of actualized freedom, the world of spirit produced from within itself as a second nature."), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn167",
      "id": "fn167r"
    }
  }, [_vm._v("37")])])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "p23"
    }
  }), _vm._v("We thus see that the transposition of a merely subjective concept of freedom—a concept closed off in its own rationality—into an objectivity that is its own product is the decisive source for the movement of the "), _c('i', [_vm._v("Verwirklichung")]), _vm._v(" of abstract law. The doctrine of objective spirit describes the constitution of the abstract freedom of the legal person in a universe of objective determinations and the legal, social, and political institutions that give that freedom coherence and actuality. It is by developing itself within a system of objective historical configurations"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn168",
      "id": "fn168r"
    }
  }, [_vm._v("38")]), _vm._v("—whose concept or principle lies in the subjectivity of spirit—that freedom reveals its properly idealized ("), _c('i', [_vm._v("idéel")]), _vm._v(") character. The idea of freedom (“not the idea that [men] have of it, but the idea that they "), _c('i', [_vm._v("are")]), _vm._v("”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn169",
      "id": "fn169r"
    }
  }, [_vm._v("39")]), _vm._v(") is thus objective—or rather, it is nothing other than a process of becoming-objective. However, all the figures of objective freedom must be passed through in order for its ideal (subjective-objective) nature to become manifest, a nature that is at first ensconced in the formalism of its (simple) concept.")]), _vm._v(" "), _c('p', [_vm._v("Law is the "), _c('i', [_vm._v("idea")]), _vm._v(" of freedom in that it actualizes freedom’s (and thus spirit’s) tendency to inscribe its originally subjective and self-centered dimension in the objectivity of a world; that is to say, to express itself in the register of its other: necessity."), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn170",
      "id": "fn170r"
    }
  }, [_vm._v("40")]), _vm._v(" The speculative definition of objective spirit or law could thus be "), _c('i', [_vm._v("freedom speaking itself in the language of necessity")]), _vm._v(". This only appears to be a paradox, for within a dialectical perspective, freedom “is not merely an independence of the Other won outside the Other”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn171",
      "id": "fn171r"
    }
  }, [_vm._v("41")]), _vm._v("—rather, it consists—a grand Hegelian theme—in being at home with oneself in the other ("), _c('i', [_vm._v("Beisichsein im Anderen")]), _vm._v("). The ground of being (subjectivity or freedom) is nothing if it does not give itself being (objectivity, necessity) and if that being does not become the "), _c('i', [_vm._v("contradiction")]), _vm._v(" that freedom must overcome to constitute itself.")]), _vm._v(" "), _c('h2', {
    staticClass: "ah",
    attrs: {
      "id": "ah0202"
    }
  }, [_vm._v("The Stratification of Law")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Freedom is not only a metaphysical property or practical determination of the subjective will: it includes a crucial dimension of objectification, of external "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p24"
    }
  }), _vm._v("realization, without which it would be illusory or pointless, not having gone through the experience of negativity. In fact, it is only after passing through abstract (private) law and subjective morality (which is subjective because it is structured by the normative expectations of a subject) and arriving at the third stratum of objective spirit, ethicality,"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn172",
      "id": "fn172r"
    }
  }, [_vm._v("42")]), _vm._v(" that the full scope of this conception of freedom becomes objective and is revealed, having negated itself in its first expression and thereby realized itself. Indeed, "), _c('i', [_vm._v("Sittlichkeit")]), _vm._v(" is “self-conscious "), _c('i', [_vm._v("freedom")]), _vm._v(" become nature.”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn173",
      "id": "fn173r"
    }
  }, [_vm._v("43")]), _vm._v(" In other words, it is the process by which the individual, in his or her claim to freedom—which is absolute, but absolutely subjective, and thus abstract—encounters freedom already realized, so to speak, in front of him or her as a world to be made his or her own. In an ethical universe made up of norms and institutions whose center of gravity is the state, the individual discovers the objective presuppositions that precede his or her attempt at normative (legal and moral) self-determination and give that attempt meaning by circumscribing it and separating it from any arbitrariness it might contain within itself. The doctrine of objective spirit can then be seen for what it is: an "), _c('i', [_vm._v("institutionalism")]), _vm._v("."), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn174",
      "id": "fn174r"
    }
  }, [_vm._v("44")]), _vm._v(" Indeed, the doctrine states that humans only achieve true freedom—that is, ultimately, their own humanity—by recognizing the objective mediations (i.e., the political, social, familial, as well as legal institutions) that make it possible for this freedom to be part of the real and by ceasing to see these institutions as obstacles to their autonomy, instead adhering to them as the being or substance of their own aims. Statute laws, customs, and mores, says Hegel, are the “universal language” in which the “universal substance”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn175",
      "id": "fn175r"
    }
  }, [_vm._v("45")]), _vm._v(" in which freedom participates is expressed. The sphere of objective spirit is thus the sphere of “institutions of meaning”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn176",
      "id": "fn176r"
    }
  }, [_vm._v("46")]), _vm._v(" if by that is meant everything that contributes to anchoring subjects’ aims in a normative universe that "), _c('i', [_vm._v("appears")]), _vm._v(" as quasi natural to them though in reality it "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p25"
    }
  }), _vm._v("is the work of subjectivity itself—albeit a subjectivity that floats, so to speak, above empirical subjects.")]), _vm._v(" "), _c('p', [_vm._v("We must still wonder why, beyond the speculative justification of the moment of necessary exteriorization that defines objective spirit, Hegel chose the name "), _c('i', [_vm._v("law")]), _vm._v(" to designate the entirety of objective spirit and not, for example, the name "), _c('i', [_vm._v("Sittlichkeit")]), _vm._v(" (which would be particularly fitting since ethical life or, better, “ethicality” ("), _c('i', [_vm._v("Sittlichkeit")]), _vm._v(") is “the "), _c('i', [_vm._v("unity")]), _vm._v(" and the "), _c('i', [_vm._v("truth")]), _vm._v("”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn177",
      "id": "fn177r"
    }
  }, [_vm._v("47")]), _vm._v(" of abstract law and morality, which are its normative and abstract components). An initial though external reason is that this vocabulary reflects the continuity between Hegel’s arguments and the still-dominant problematic of natural law—or at least, its terminology. But the metonymic usage of the term "), _c('i', [_vm._v("law")]), _vm._v(" is also internally justified: if it is true that legal relations are objectivity itself, then the term "), _c('i', [_vm._v("law")]), _vm._v(" is a fitting way of referring to the movement of self-constitution in otherness that is the general meaning of objective spirit. But this terminological choice comes at a price: a significant expansion, even "), _c('i', [_vm._v("stratification")]), _vm._v(", of the concept of law.")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "bqs"
  }, [_vm._v("Law, which is to be taken comprehensively, not only as restricted juridical law, but as the embodiment of all determinations of freedom. . . . For an embodiment is a right only on the basis of the free substantial will."), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn178",
      "id": "fn178r"
    }
  }, [_vm._v("48")])])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("This multiplication is explained by the speculative decision to make law—understood as a "), _c('i', [_vm._v("system")]), _vm._v(" of determinations of objective spirit—the generic concept for thinking the unity of the seemingly heterogeneous field of the objective manifestations of freedom or will. Many will judge this multiplication of the concept to be arbitrary, even exorbitant, because it goes well beyond the properly legal sphere (of either private law or internal and external public law). But for Hegel, the expansion is "), _c('i', [_vm._v("necessary")]), _vm._v(": law and rights, understood as the “"), _c('i', [_vm._v("existence")]), _vm._v(" of the "), _c('i', [_vm._v("free will")]), _vm._v(",”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn179",
      "id": "fn179r"
    }
  }, [_vm._v("49")]), _vm._v(" cover the entire set of processes by which freedom is objectivized, and thus cannot be restricted to the abstract (and thus not autonomous) moment of law in the legal sense, no matter how important that moment may be. Ultimately, the result of the concept of law as it is presented"), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p26"
    }
  }), _vm._v(" in the introduction to the "), _c('i', [_vm._v("Philosophy of Right")]), _vm._v(" is that law is coextensive with the entirety of objective spirit. As a consequence, not only legal rights but also the “right of the subjective will,”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn180",
      "id": "fn180r"
    }
  }, [_vm._v("50")]), _vm._v(" the “right of the world spirit,”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn181",
      "id": "fn181r"
    }
  }, [_vm._v("51")]), _vm._v(" morality, philosophy of history, and, of course, political theory ("), _c('i', [_vm._v("Staatsrecht")]), _vm._v(", which is not the same as public law in the strictly legal sense of the term) all fall under the enlarged concept (the "), _c('i', [_vm._v("idea")]), _vm._v(") of law. There is a fundamental point here for Hegel that is tightly bound up with his reformulation of natural law. If Hegel finds it necessary—and in this sense we may say that he remains deeply indebted to natural law—to propose a unitary and encompassing concept of law that overcomes the fragmentation of legal, ethical, and positive political disciplines, then his concept of law cannot be arrived at by expanding the characteristic structure of the sphere of private law, that is, the structure of property relations. While it is legitimate to reconstruct the entire sphere of private law on the basis of the legal relationship between persons and things (i.e., on the concept of property), it is equally legitimate to adopt a concept of law that is anterior to the matrix structure of abstract/private law and is foundational for it.")]), _vm._v(" "), _c('p', [_vm._v("Thus, appearances notwithstanding, it is not arbitrary to apply the name of law to "), _c('i', [_vm._v("all")]), _vm._v(" forms of freedom’s objectivization—though freedom is usually thought of as a property of the subjective will. Moreover, “strict” law, private law, exemplifies the process of objective spirit, because it subjects to objective norms the subjectivity of the maxims for action: it objectifies subjective claims by submitting them to procedures of formalization, thereby giving them a universal dimension. The ordinary concept of law and right also includes this double dimension of subjectivity and objectivity; we need only be a bit attentive to see this. Right is “subjective right” because it assumes a subject (the person), and, as we all know, since Hobbes, modern thought has endeavored to reconstruct the entire legal system on the basis of the individual, as a holder of rights. But it is also “objective law,” because the obligations that result from the exercise of subjective rights and the procedures for (re)establishing them form an already present order, a normative system that is supposed to be complete—and we know how important the “absence of lacuna” "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p27"
    }
  }), _vm._v("was for the rise of legal positivism"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn182",
      "id": "fn182r"
    }
  }, [_vm._v("52")]), _vm._v("—and on the basis of which it is possible, as the Roman jurisprudents used to say, to “give each his due.” Thus, by stratifying law, Hegel is not unduly expanding the notion of law but is rather trying to emphasize that its principle coincides with his own understanding of freedom presupposing, in a circular way, its own objectification. One may or may not agree with this interpretation, but the fact remains that it determines Hegel’s conception of the articulation of private law, morality, and "), _c('i', [_vm._v("Sittlichkeit")]), _vm._v(" in a coherent and systematic totality, one ordered by the principle of the objectivization of freedom.")]), _vm._v(" "), _c('p', [_vm._v("The result is that the thesis of Hegelian antilegalism that I presented at the beginning of this chapter is untenable. Otherwise, how are we to explain the fact that Hegel, in spite of his acute awareness of the limits of “narrow legal law,” chose that very term to metonymically designate the entire sphere of objective spirit? If there is antilegalism in Hegel, it can only be what I have called weak antilegalism—that is, a rejection of the argument that the legal order is self-sufficient; an argument that was supported by the positivists and systematized by Kelsen."), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn183",
      "id": "fn183r"
    }
  }, [_vm._v("53")]), _vm._v(" Furthermore, the expansion and stratification of law are strict corollaries of calling into question law as a closed system: it is because “abstract law” cannot be considered a closed system (for reasons we must still analyze) that it is possible and necessary to have an enlarged concept of law that makes it possible to formulate nonlegal (in the strict sense of the term) conditions for the efficacy of law. To better understand this weak antilegalism, we must examine the precise reasons why Hegel calls private law "), _c('i', [_vm._v("abstract")]), _vm._v(" law.")]), _vm._v(" "), _c('h2', {
    staticClass: "ah",
    attrs: {
      "id": "ah0203"
    }
  }, [_vm._v("The Abstraction of Abstract Law")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("In what way is law “in the legal sense” abstract, and how does its abstraction point to an insufficiency? Indisputably, the description of private law, the law "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p28"
    }
  }), _vm._v("of jurists, as “abstract” and “formal” implies a relativization of this first objectification of freedom. But Hegel’s constant reminder of this abstraction does not imply any disdain for law. Of course, Hegel rejects "), _c('i', [_vm._v("legalism")]), _vm._v(", which would make law and rights the truth of objective spirit and the foundation of ethicality—but he also refuses to treat law as a mere superstructure, a deformed expression of ethical (sociopolitical) reality. Because of its very abstraction, law includes a logical and historical necessity that must be recognized. The “formal right of abstract personality,” like each of the figures of objective spirit, gives a “determinate shape and existence to freedom,”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn184",
      "id": "fn184r"
    }
  }, [_vm._v("54")]), _vm._v(" and this is the perspective from which the fundamental categories of formal law must be interpreted. Hegel’s analysis of person, property, contracts, and forms of violation and reestablishment of law thus aim to show how these concepts, as they operate in legal reasoning, constitute outlines of the objectification of freedom—outlines that give freedom increasingly formal—and thus "), _c('i', [_vm._v("in a sense")]), _vm._v(" more universal—expression. Thus, legal abstraction makes it possible for freedom, as it becomes objectified in externality and nonfreedom, to lose the equally abstract subjectivity of individual consciousness. The formalism of law, which marks its limitation with respect to the concreteness of ethical-political"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn185",
      "id": "fn185r"
    }
  }, [_vm._v("55")]), _vm._v(" institutions, is thus far from having only negative aspects, since it allows legal reasoning to distance itself from the material singularity of a case and to access the universality of "), _c('i', [_vm._v("form")]), _vm._v(". Hence, the formalities with which law accompanies elementary legal acts are what make these acts “valid before the law,”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn186",
      "id": "fn186r"
    }
  }, [_vm._v("56")]), _vm._v(" and, in general, the progress of legal consciousness has kept pace with the formalization of procedures and techniques of reasoning. Whence the following statement, at first glance surprising from a philosopher quick to denounce all formalism:")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "bqs"
  }, [_vm._v("Both feeling, which remains confined to the subjective, and reflection, which clings to its abstract essences, reject such formalities, whereas the "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p29"
    }
  }), _vm._v("dead understanding may for its part hold on to them in preference to the thing ["), _c('i', [_vm._v("Sache")]), _vm._v("] itself and multiply them indefinitely."), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn187",
      "id": "fn187r"
    }
  }, [_vm._v("57")])])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("This is why the Hegelian definition of law deliberately distances itself from the common preconception that law implies the (reciprocal) limitation of freedoms, the mutual restriction of subjective rights. That idea found a fitting framework in modern natural law as interpreted by Hobbes: the rule of (natural and positive) law passes through a restriction of natural rights: it is established when individuals unilaterally transfer their subjective natural rights to the sovereign, who, in exchange, guarantees them the security they lack in the state of nature. This is why the transfer of rights must be total—with the significant, sole exception of inalienable rights"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn188",
      "id": "fn188r"
    }
  }, [_vm._v("58")]), _vm._v("—if it is to be effective. Rousseau, adopting this perspective,"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn189",
      "id": "fn189r"
    }
  }, [_vm._v("59")]), _vm._v(" demonstrated that it does not necessarily imply a monarchic system, as might perhaps be feared. This classical conception of the restriction of rights by law has been adopted by thinkers who share neither Hobbes’s nor Rousseau’s choices. Kant, for example, sees law as implying a limitation or restriction on every individual’s free choice so that law “is therefore the sum of the conditions under which the choice of one can be united with the choice of another in accordance with a universal law of freedom.”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn190",
      "id": "fn190r"
    }
  }, [_vm._v("60")]), _vm._v(" This postulate of reason lies at the root of “law in the strict sense” because it is the basis for any possible "), _c('i', [_vm._v("constraint")]), _vm._v(" being enacted on someone who, by her action, violates the universal law. For Hegel, however, such an understanding of law and rights is based on a philosophical error "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p30"
    }
  }), _vm._v("since it derives the “rational will” from the “will of the single person ["), _c('i', [_vm._v("des Einzelnen")]), _vm._v("] in his distinctive arbitrariness.”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn191",
      "id": "fn191r"
    }
  }, [_vm._v("61")]), _vm._v(" On that view, which presupposes the reciprocal externality of the universal and the singular, of law and rights, the ascendancy of the former over the latter constitutes a limitation, a constraint, whereas for Hegel, the submission of individual choice to universal law is what frees the individual from his internal limitations, which result from the fact that he is "), _c('i', [_vm._v("merely")]), _vm._v(" particular. At stake in this debate is the very status of law as an instance of rational universality within the order of willing. It is quite accurate to say that law, as an order objectively governed by relations between independent persons, involves a restriction of their free capacity for choice, but it is the "), _c('i', [_vm._v("arbitrary")]), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn192",
      "id": "fn192r"
    }
  }, [_vm._v("62")]), _vm._v(" aspect of the individual subjective will in its initial naturalness that is restricted, while the objective will that is the source of all legal actions is promoted. This understanding presupposes a clear distinction—already found in Kant"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn193",
      "id": "fn193r"
    }
  }, [_vm._v("63")]), _vm._v("—between the free capacity for choice and will. But while Kant establishes a functional hierarchy between "), _c('i', [_vm._v("Willkür")]), _vm._v(" and "), _c('i', [_vm._v("Wille")]), _vm._v(", Hegel makes the former a (necessary though contradictory) moment in the determination and particularization of the latter. It is precisely because law strives to go beyond the subjective, arbitrary, and structurally contradictory"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn194",
      "id": "fn194r"
    }
  }, [_vm._v("64")]), _vm._v(" will by subjecting it to the constraints of an objective normative order that it is not a limitation but rather an objectivization of the will on which the actuality of the will’s freedom depends.")]), _vm._v(" "), _c('p', [_vm._v("Hegel’s interpretation of the notion of legal personality is indicative of his concern to make abstract law a manifestation—though no doubt an imperfect one—of freedom as it becomes objective: a freedom no longer closed in on itself but one that inscribes itself in the world and in so doing overcomes its finitude and reaches a form of universality. Significantly, Hegel’s reconstruction of abstract law makes personality its "), _c('i', [_vm._v("sole")]), _vm._v(" principle because personality "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p31"
    }
  }), _vm._v("inextricably links "), _c('i', [_vm._v("law")]), _vm._v(", "), _c('i', [_vm._v("rights")]), _vm._v(", and "), _c('i', [_vm._v("freedom")]), _vm._v(": “law and all its determinations are based on the free personality alone, a self-determination, which is the very contrary of determination by nature.”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn195",
      "id": "fn195r"
    }
  }, [_vm._v("65")]), _vm._v(" But what, exactly, is personality? Here is Hegel’s definition:")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "bqs"
  }, [_vm._v("It is inherent in "), _c('i', [_vm._v("personality")]), _vm._v(" that, as "), _c('i', [_vm._v("this")]), _vm._v(" person, I am completely determined in all respects (in my inner arbitrary will, drive, and desire, as well as in relation to my immediate external existence ["), _c('i', [_vm._v("Dasein")]), _vm._v("]), and that I am finite, yet totally pure self-reference, and thus know myself in my finitude as "), _c('i', [_vm._v("infinite")]), _vm._v(", "), _c('i', [_vm._v("universal")]), _vm._v(", and "), _c('i', [_vm._v("free")]), _vm._v("."), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn196",
      "id": "fn196r"
    }
  }, [_vm._v("66")])])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("A person can be defined as a pure relation of freedom to itself that is expressed as an indefinite—and in that sense, formal—relation between the person and things. The person, the starting point for the process of objective spirit, inherits the determination that characterizes free spirit, the culmination of subjective spirit: it is “"), _c('i', [_vm._v("free will")]), _vm._v(", which is "), _c('i', [_vm._v("for itself as free will.")]), _vm._v("”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn197",
      "id": "fn197r"
    }
  }, [_vm._v("67")]), _vm._v(" But, in the objectivized and formalized figure of the person, the will detaches itself from the context in which its concept appears, that is, finite subjectivity. Hegel is careful to point out that the “"), _c('i', [_vm._v("legal")]), _vm._v(" will” is not the “subjective will” but rather an “objective will,”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn198",
      "id": "fn198r"
    }
  }, [_vm._v("68")]), _vm._v(" specifying that “the objective will is rational in itself, i.e. in its "), _c('i', [_vm._v("concept")]), _vm._v(".”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn199",
      "id": "fn199r"
    }
  }, [_vm._v("69")]), _vm._v(" The difference between these two forms of will is crucial. Whereas the subjective will exhausts itself in willing its own freedom, the objective legal will—that is, first and foremost, personality—transposes the self-relation that constitutes its freedom into an indeterminate or formal objectivity:")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "bqs"
  }, [_vm._v("The person must give himself an external "), _c('i', [_vm._v("sphere of freedom")]), _vm._v(" in order to have being as Idea. The person is the infinite will, the will which has being in and for itself, in this first and as yet wholly abstract determination. Consequently, "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p32"
    }
  }), _vm._v("this sphere distinct from the will, which may constitute the sphere of its freedom, is likewise determined as "), _c('i', [_vm._v("immediately different")]), _vm._v(" and "), _c('i', [_vm._v("separable")]), _vm._v(" from it."), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn200",
      "id": "fn200r"
    }
  }, [_vm._v("70")])])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("The objective will wills itself in things: it affirms itself as a capacity—in principle, unlimited—for appropriating objectivity or, in other words, as an infinite capacity for self-objectivization. The legal capacity inherent in personality is the basis for “the universal right to appropriate natural things.”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn201",
      "id": "fn201r"
    }
  }, [_vm._v("71")]), _vm._v(" Thus, if personality is the “(itself abstract) basis of abstract and hence "), _c('i', [_vm._v("formal")]), _vm._v(" right,”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn202",
      "id": "fn202r"
    }
  }, [_vm._v("72")]), _vm._v(" its true expression is the formal (legal) act of appropriating things, an act empirically expressed in material possession and in even the most rudimentary symbols of possession, such as shaping and marking:")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "bqs"
  }, [_c('i', [_vm._v("Personality")]), _vm._v(" alone confers a right to "), _c('i', [_vm._v("things")]), _vm._v(", and consequently that personal right is in essence a "), _c('i', [_vm._v("right of things")]), _vm._v("—“thing” ["), _c('i', [_vm._v("Sache")]), _vm._v("] being understood in its general sense as everything external to my freedom, including even my body and my life."), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn203",
      "id": "fn203r"
    }
  }, [_vm._v("73")])])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("The significance of this concept of personality can be measured by the effects it has on the common understanding of self-possession: the "), _c('i', [_vm._v("res")]), _vm._v(" that can be possessed include my own body and the products of my mind as well natural and artificial objects. Hegel treats personal freedom not as a natural or essentially given but rather as a particular case—one with very interesting consequences—of a person’s investment in objectivity. Just as in order to be considered the legal proprietor of a thing, a person must actually appropriate it through usage and not just passively hold it;"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn204",
      "id": "fn204r"
    }
  }, [_vm._v("74")]), _vm._v(" she must also take possession of herself in order to be fully—physically, intellectually, and legally—sui juris:")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "bqs"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "p33"
    }
  }), _vm._v("The human being, in his "), _c('i', [_vm._v("immediate")]), _vm._v(" concrete existence ["), _c('i', [_vm._v("Existenz")]), _vm._v("] in himself, is a natural entity, external to his own concept; it is only through the "), _c('i', [_vm._v("development")]), _vm._v(" ["), _c('i', [_vm._v("Ausbildung")]), _vm._v("] of his own body and spirit, "), _c('i', [_vm._v("essentially")]), _vm._v(" by means of "), _c('i', [_vm._v("his self-consciousness comprehending itself as free")]), _vm._v(", that he takes possession of himself and becomes his own property as distinct from that of others. Or to put it the other way round, this taking possession of oneself consists also in translating into "), _c('i', [_vm._v("actuality")]), _vm._v(" what one is in terms of one’s concept (as "), _c('i', [_vm._v("possibility")]), _vm._v(", capacity ["), _c('i', [_vm._v("Vermögen")]), _vm._v("], or predisposition). By this means, what one is in concept is posited for the first time as one’s own."), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn205",
      "id": "fn205r"
    }
  }, [_vm._v("75")])])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("It is from the necessity that man take possession of his own body and mind by educating and cultivating them that Hegel deduces the legal absurdity of slavery and bondage, which can only be justified if the egalitarian formalism of law is abandoned, as is the case, for example, when legal capacity is connected to the possession of a certain social or political status. We see, then, the value of the egalitarian formalism of law. When legal capacity is based on status, the personality of humans is denied, as certain people are refused full possession of their bodies, which constitutes a negation of the principle of free personality and, thereby, is “absolutely contrary to law.”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn206",
      "id": "fn206r"
    }
  }, [_vm._v("76")]), _vm._v(" As Hegel declared to his students in Berlin, “Man is implicitly rational; herein lies the possibility of equality of right for all men,—the futility of a rigid distinction between races that have rights and those that have none.”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn207",
      "id": "fn207r"
    }
  }, [_vm._v("77")]), _vm._v(" But Hegel also objects to humanist, natural law arguments against the “so-called legal institution of slavery” as well as to historicist arguments; he objects to the former on the grounds that they invoke a problematic “human nature,” for personal freedom is anything but a "), _c('i', [_vm._v("natural")]), _vm._v(" property or right, and to the latter on the grounds that, by reducing property to possession, they tend to justify notions such as eminent domain and thereby indirectly justify bondage."), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn208",
      "id": "fn208r"
    }
  }, [_vm._v("78")])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "p34"
    }
  }), _vm._v("A fundamental and inalienable right, personality is a universal though indeterminate power (a “capacity”) to exercise rights or, rather, the right from which all others are derived: the right to appropriate material things. Property, the completed—because legally objectified—form of possession gives expression to the primary legal relationship between person and thing from which the entire construction of law follows. Property is what allows my will and my personality to become objective and thereby truly mine. In this way, the entire sphere of abstract law can be considered to deal with real rights in the technical sense of the term: that is, with the ownership, acquisition, transfer, violation, and restitution of "), _c('i', [_vm._v("res")]), _vm._v(". This is why a margin note in the "), _c('i', [_vm._v("Philosophy of Right")]), _vm._v(" indicates that property is the thread that runs throughout the entire examination of the sphere of abstract law,"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn209",
      "id": "fn209r"
    }
  }, [_vm._v("79")]), _vm._v(" and this is why Hegel rejects the traditional distinction (which goes back to Gaius’s "), _c('i', [_vm._v("Institutes")]), _vm._v(") between the right of persons and the right to things: “personal right is in essence a "), _c('i', [_vm._v("right to things")]), _vm._v(".”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn210",
      "id": "fn210r"
    }
  }, [_vm._v("80")])]), _vm._v(" "), _c('p', [_vm._v("Of course, the choice to present the entirety of abstract law on the basis of the ownership of material goods is far from innocuous. It is intended, first and foremost, to counter Roman law, according to which the “right to have right(s)” is differentially distributed depending on a person’s status—and even, according to the common teaching, on a triple status: "), _c('i', [_vm._v("status libertatis")]), _vm._v(", "), _c('i', [_vm._v("status civitatis")]), _vm._v(", "), _c('i', [_vm._v("status familiae")]), _vm._v(":")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "bqs"
  }, [_vm._v("As for what is called the "), _c('i', [_vm._v("right of persons")]), _vm._v(" in Roman law, it regards a human being as a person only if he enjoys a certain "), _c('i', [_vm._v("status")]), _vm._v(" (see Heineccius, "), _c('i', [_vm._v("Elementa iuris civilis")]), _vm._v(" [1728], § 75); hence in Roman law even personality itself, as opposed to slavery, is merely an "), _c('i', [_vm._v("estate")]), _vm._v(" ["), _c('i', [_vm._v("Stand")]), _vm._v("] or condition ["), _c('i', [_vm._v("Zustand")]), _vm._v("]. . . . "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p35"
    }
  }), _vm._v("The right of persons in Roman law is therefore not the right of the person as such, but no more than the right of the "), _c('i', [_vm._v("particular")]), _vm._v(" person."), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn211",
      "id": "fn211r"
    }
  }, [_vm._v("81")])])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("This amounts to “discuss[ing] the right of the person in his "), _c('i', [_vm._v("particular determinacy")]), _vm._v(" before the universal right of personality.”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn212",
      "id": "fn212r"
    }
  }, [_vm._v("82")]), _vm._v(" Thus, the attention paid by the dominant legal tradition to the statutory conditions of personality is not in accordance with the objectively universal content of that concept, though the latter is at the foundation of all legal determinations. The freedom of individual private property is the concrete expression of the objectification by which personality is realized. Rosenzweig is thus right to say that the Hegelian conception of law espoused the point of view of free ownership as it is realized when the rigid structure of a society of orders is abolished and to point out that in so doing, Hegel was the first to attempt to philosophically account for “what has transpired in half of Europe since the night of August 4”: the elimination of privilege, of "), _c('i', [_vm._v("lex privata")]), _vm._v(", as the source and foundation of right."), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn213",
      "id": "fn213r"
    }
  }, [_vm._v("83")]), _vm._v(" According to Hegel, exclusive private property expresses the very essence of abstract law, which is to objectify—to the point of reifying—personal freedom. This is why the set of determinations contained in this sphere (law of contracts, forms of violating and reestablishing law) can and must be systematically ordered on the basis of personal freedom.")]), _vm._v(" "), _c('p', [_vm._v("To summarize, the formalism of law has a positive aspect and even a certain fecundity. No doubt abstract law is the expression of a freedom that is itself still abstract, for it is situated in what is “"), _c('i', [_vm._v("immediately different")]), _vm._v(" and "), _c('i', [_vm._v("separable")]), _vm._v(" from it”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn214",
      "id": "fn214r"
    }
  }, [_vm._v("84")]), _vm._v("—but this objectifying abstraction "), _c('i', [_vm._v("frees")]), _vm._v(" the personality from what is "), _c('i', [_vm._v("merely")]), _vm._v(" subjective and particular in it. Hence, legal personality is the full, because objectified, expression of subjective personality, which it presupposes and reinforces. Abstract law of course does not give objective freedom its content (which is, ultimately, political), but it defines the abstractly universal relation between humans and material nature, concretely expressed in work, as well as the relations between people, provided that these relations are not consciously ordered by an ethical-political end that surpass it. As the "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p36"
    }
  }), _vm._v("1802 article on natural law stated, the conversion of particularity into universality is “that by which the sphere of law is constituted.”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn215",
      "id": "fn215r"
    }
  }, [_vm._v("85")]), _vm._v(" Thus, the abstraction of private law guarantees the universal validity of its principles. Because it is abstract, this law belongs to no place or time (which of course does not mean that it has been honored always and everywhere). In this sense, it is insurmountable. For Hegel, there can be no freedom against law.")]), _vm._v(" "), _c('h2', {
    staticClass: "ah",
    attrs: {
      "id": "ah0204"
    }
  }, [_vm._v("The Actualization of Abstract Law: Civil Society")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Abstract law defines the universal form of the objectivization of freedom—but only its form. Indeed, its formalism prevents it from engendering an actual order. Hegel criticizes the “fiction of a "), _c('i', [_vm._v("state of nature")]), _vm._v("”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn216",
      "id": "fn216r"
    }
  }, [_vm._v("86")]), _vm._v(" but otherwise repeats Hobbes’s reasoning. Hobbes emphasized this in order to demonstrate the necessity of exiting the state of nature (“exeundem e statu naturae,” as the expression from "), _c('i', [_vm._v("De Cive")]), _vm._v(" goes): if every person has a right to every thing, then in fact no person has any power over any thing until a principle of actuality (which cannot emerge from abstract law) intervenes and converts this unlimited, though formal, right into guaranteed possession of delimited but real goods. This is no doubt a trivial point, but common legalism requires that it be emphasized: law is not realized by itself, which makes it untenable to see it as a self-sufficient normative order.")]), _vm._v(" "), _c('p', [_vm._v("The need for there to be an operator to actualize abstract law becomes clear in the case of the equality of rights proclaimed by the Declaration of the Rights of Man and Citizen. There, equality is made an inalienable right; Hegel, on the other hand, makes it a simple analytic property of abstract law. The fact that people—all people—are legally equal is included in the concept of personhood, which is the sole inalienable and imprescriptible legal good:")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "bqs"
  }, [_vm._v("The right to such inalienable things is imprescriptible, for the act whereby I take possession of my personality and substantial essence and make myself a responsible being with moral and religious values and capable of holding "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p37"
    }
  }), _vm._v("rights removes these determinations from that very externality which alone made them capable of becoming the possessions of someone else."), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn217",
      "id": "fn217r"
    }
  }, [_vm._v("87")])])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("Because personhood is a formal construction that disregards all real differences between individuals—including, first and foremost, inequalities in social position and fortune"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn218",
      "id": "fn218r"
    }
  }, [_vm._v("88")]), _vm._v("—by definition, everyone has the right to it. This equality of right(s) boils down to "), _c('i', [_vm._v("freedom")]), _vm._v(" insofar as freedom can be reduced to a legal relation, that is, to personal freedom in the most abstract sense, as an absence of "), _c('i', [_vm._v("legal")]), _vm._v(" dependence on others. Thus, abstract law defines the base structure of the relations between humans when these relations are mediated by things, that is, are neither moral nor ethical relations but strictly legal. Law gives us a picture of what a society of persons who “only as owners of property . . . have existence ["), _c('i', [_vm._v("Dasein")]), _vm._v("] for each other”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn219",
      "id": "fn219r"
    }
  }, [_vm._v("89")]), _vm._v(" would look like, but such a society is no more than an abstraction or idealization of civil society and real politics. A keen and attentive observer of England’s economic and social transformations during the Industrial Revolution, Hegel is fully aware of the potentially harmful consequences of unequal implementation of formal legal equality: it is the cause of conflicts between individuals and of destitution for many. But it would be a mistake to ask law to solve a problem of which it is at most an indication and not a cause: the inequalities that formal legal equality may cover over “belong to another sphere, that of civil society.”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn220",
      "id": "fn220r"
    }
  }, [_vm._v("90")])]), _vm._v(" "), _c('p', [_vm._v("Why is it incumbent on "), _c('i', [_vm._v("bürgerliche Gesellschaft")]), _vm._v(" in particular to actualize abstract law? The question can be answered from two points of view. First, from a "), _c('i', [_vm._v("systematic")]), _vm._v(" point of view, it is explained by the position of civil society within the economy of "), _c('i', [_vm._v("Sittlichkeit")]), _vm._v(". Ethicality guarantees the connection—or rather, the mutual copenetration—of the subjective and objective poles of freedom, hitherto abstractly separated from one another, as are formal-objective law and the “right of "), _c('i', [_vm._v("subjective freedom")]), _vm._v(".”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn221",
      "id": "fn221r"
    }
  }, [_vm._v("91")]), _vm._v(" Of course, the ethical reconciliation of objectivity and subjectivity is not their completed reconciliation: it remains "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p38"
    }
  }), _vm._v("but an "), _c('i', [_vm._v("objective")]), _vm._v(" reconciliation of the two dimensions of spirit, which still appear distinct within it, whereas, according to its speculative concept, they come from an internal division within a single totality that, as idea, is only thinkable as subject-object. But in any case, spirit becomes truly objective as an ethical totality in the sense that objectivity ceases to be a formal predicate of spirit, as it is in the sphere of law, and is revealed to be its true—because mediated or second—nature and is thereby verified: “Ethicality is duty, substantial law, second nature (as it has rightly been called); for man’s first nature is his immediate animal existence.”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn222",
      "id": "fn222r"
    }
  }, [_vm._v("92")]), _vm._v(" Hence, ethicality implies the actualization of the abstract concept of law and ensures that its formalism is surpassed. But of the three spheres that ethicality includes, the task of actualization falls to "), _c('i', [_vm._v("civil society")]), _vm._v(" in particular. The family, which corresponds to the moment of immediate naturalness within the ethical sphere, is essentially located at a “sublegal” level; as we know, Hegel condemns the “infamy” of Kant’s “legalization” of marriage, which according to Hegel obliterates the specific determination of the natural moment of ethical life."), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn223",
      "id": "fn223r"
    }
  }, [_vm._v("93")]), _vm._v(" The state, for its part, is superlegal, at least if one sticks to the narrow understanding of the concept of law. Civil society, the middle term between the family and the state, is the space where abstract (private) law is actually realized. Conversely, abstract private law must be considered a working draft or formal framework of civil society.")]), _vm._v(" "), _c('p', [_vm._v("Second, from a "), _c('i', [_vm._v("historical")]), _vm._v(" point of view, we know that for Hegel, the (relatively) autonomous constitution of civil society is a distinctive property of modern ethicality:")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "bqs"
  }, [_vm._v("Civil society is the [stage of] difference which intervenes between the family and the state, even if its full development occurs later than that of the state; for as difference, it presupposes the state, which it must have before it as a self-sufficient entity in order to subsist itself. Besides, the creation of civil society belongs to the modern world, which for the first time allows all determinations of the Idea to attain their rights."), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn224",
      "id": "fn224r"
    }
  }, [_vm._v("94")])])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "p39"
    }
  }), _vm._v("Hegel here gives expression to a still-diffuse consciousness of the irreducibility of the social bond to its political forms and profoundly transforms the term "), _c('i', [_vm._v("civil society")]), _vm._v(", which previously had been synonymous with "), _c('i', [_vm._v("political society")]), _vm._v("."), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn225",
      "id": "fn225r"
    }
  }, [_vm._v("95")]), _vm._v(" Hegel’s wholly intentional innovation is meant to correspond to the creation of a space of production, exchanges, and social interactions that is to a large degree independent from political authority properly speaking, which, in Hegelian terms, is charged with the universal. In a pure market society, interdependencies and the objective coordination of individuals’ needs, activities, and self-interested projects would render concerted actions by a public power useless, even harmful. But civil society in the Hegelian sense is not reducible to the spontaneous order of the market. It is thus both conceptually and actually inseparable from the modern (constitutional) state as well as from a certain configuration of law. Indeed, if the existence of civil society presupposes in general "), _c('i', [_vm._v("a")]), _vm._v(" state, only the "), _c('i', [_vm._v("rational")]), _vm._v(" state is strong enough to let the moment of social life develop freely for itself. The rational state, and only the rational state, offers an “actuality” and a “guarantee” of the “"), _c('i', [_vm._v("prevailing principles of")]), _vm._v(" ["), _c('i', [_vm._v("law in force")]), _vm._v("],” that is, the rights of “freedom of property and also of personal freedom, the principles of civil society, of its industry and of the communities, and of the regulated performance of the particular authorities subject to the [statute-]laws.”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn226",
      "id": "fn226r"
    }
  }, [_vm._v("96")]), _vm._v(" This explains why civil society, in its complex connection to the postrevolutionary state, is the authentic—that is to say, "), _c('i', [_vm._v("nonpolitical")]), _vm._v("—realization of the equally modern demand (which materialized with the French Revolution) for the rule of law."), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn227",
      "id": "fn227r"
    }
  }, [_vm._v("97")]), _vm._v(" Thus, the actual realization of law in itself—which in itself is not historic—is only accomplished late in history and bears a constitutive relation to the problematic of legal equality and personal freedom of which the Declarations of Rights are the manifesto.")]), _vm._v(" "), _c('p', [_vm._v("In what sense does civil society—in its concept—presuppose an abstract legal order? To find out, we must examine civil society in its economic reality: that is, we must consider it—following Hegel’s conceptualization in his Jena writings—as a system of needs. The economic subsystem perfectly illustrates the definition of civil society as “the system of ethicality, lost in its "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p40"
    }
  }), _vm._v("extremes,”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn228",
      "id": "fn228r"
    }
  }, [_vm._v("98")]), _vm._v(" split between the particularity of the egotistical aims of individuals and a universality that, because it remains separate from the particular, is merely formal:")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "bqs"
  }, [_vm._v("The determination of "), _c('i', [_vm._v("particularity")]), _vm._v(" . . . is related to "), _c('i', [_vm._v("universality")]), _vm._v(", but in such a way that the latter is its basis—though still only its "), _c('i', [_vm._v("inner")]), _vm._v(" basis; consequently, this universality is present only as a formal "), _c('i', [_vm._v("shining")]), _vm._v(" in the particular."), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn229",
      "id": "fn229r"
    }
  }, [_vm._v("99")])])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("This formal-universal takes the shape—as we have known since Adam Smith’s "), _c('i', [_vm._v("Wealth of Nations")]), _vm._v("—of an “invisible hand,” by which is meant economic regulations that ensure if not the harmony then at least the adjustment of particular ends within a “system of multilateral dependence” such that “the subsistence and welfare of the individual and his legal existence ["), _c('i', [_vm._v("Dasein")]), _vm._v("] are interwoven with, and grounded on, the subsistence, welfare, and right of all.”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn230",
      "id": "fn230r"
    }
  }, [_vm._v("100")]), _vm._v(" But the “blind necessity”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn231",
      "id": "fn231r"
    }
  }, [_vm._v("101")]), _vm._v(" of self-regulation—which cannot, on its own, guarantee the harmonious functioning of the system—is not, and cannot be, the only mode of universality’s presence within civil society. Production and exchange, the appropriation of nature to satisfy needs that the system multiplies (thus freeing economic actors from their servility to supposed “natural needs”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn232",
      "id": "fn232r"
    }
  }, [_vm._v("102")]), _vm._v("), the aleatory interaction of particular ends: all this also requires the existence of a homogenous space whose formative rules are defined by the law, that is, a formal space in the image of the economic composition of particular goals.")]), _vm._v(" "), _c('p', [_vm._v("Modern work takes the form of an abstract activity intended to satisfy needs incompletely, needs that themselves become ever more abstract because the logic of production and exchange deprives them of any semblance of naturalness. It presupposes the existence of a legal order that makes it possible to determine what belongs to whom on the basis of formalized procedures.")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "bqs"
  }, [_vm._v("In the state of affairs in which this standpoint of mediation is realized, immediate seizure (§ 488) of external objects as means to satisfaction no longer occurs, or very rarely; the objects are property. Their acquisition is, "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p41"
    }
  }), _vm._v("on the one hand, conditioned and mediated by the will of their possessors, which, as particular will, has as its aim the satisfaction of variously determined needs, just as, on the other hand, it is conditioned and mediated by the ever renewed production of exchangeable means by one’s own labour, this mediation of satisfaction by the labour of all constitutes the general resources."), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn233",
      "id": "fn233r"
    }
  }, [_vm._v("103")])])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("In other words, the formal-universal condition for the social satisfaction of needs is that every thing has an identifiable owner and an order of private law based on personal property is in place. In bourgeois civil society, there can be no res nullius, things without master, immediately appropriable. Private ownership of the means of production and exchange is the "), _c('i', [_vm._v("formal")]), _vm._v("-universal condition for the collective satisfaction of particular needs."), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn234",
      "id": "fn234r"
    }
  }, [_vm._v("104")]), _vm._v(" "), _c('i', [_vm._v("Homo oeconomicus")]), _vm._v(", who is simply man tout court, a being of needs and work, is thus the concrete historical figure of the abstract legal person."), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn235",
      "id": "fn235r"
    }
  }, [_vm._v("105")]), _vm._v(" The existence of a social space of production and exchange—that is, the system of needs—creates the conditions for the actualization of the abstract principles of the legal order. Conversely, abstract law, because it is abstract, is the general condition of production and exchange in their modern, capitalist form. The production, exchange, and consumption of commodities at the scale of a “great society,” to use Adam Smith’s expression, presupposes the homogenous basis of a universally applicable law: there is no market society without commodities and thus without a universal definition of property and the conditions of its transfer.")]), _vm._v(" "), _c('p', [_vm._v("Civil society is thus structurally congruent with private law. First, it "), _c('i', [_vm._v("presupposes")]), _vm._v(" private law as the formal condition of its own operation: without an abstract legal order, concrete social life would be impossible. Second, civil society "), _c('i', [_vm._v("actualizes")]), _vm._v(" the law because the relations between individuals and social groups offer concrete material for the formal determinations of right. As we know, Hegel thinks that civil society preserves within itself the “remnants of the state of nature.”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn236",
      "id": "fn236r"
    }
  }, [_vm._v("106")]), _vm._v(" But only the remnants; the universal is not absent from civil society as it is from a pure state of nature, which, as Hobbes proved, can only be conceived as lawless. The interaction between right and economic regulations "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p42"
    }
  }), _vm._v("within the space of exchange is precisely what demonstrates the difference between this space and a state of nature: right—the formalism of which makes a positive contribution at this level—makes possible an economic and social space that functions "), _c('i', [_vm._v("relatively")]), _vm._v(" independently from the state and its own specific modes of action. It allows for a "), _c('i', [_vm._v("civil")]), _vm._v(", rather than "), _c('i', [_vm._v("civic")]), _vm._v(", society. However, the actuality of legal formalism and “formal” economic regulations must not be overestimated, for the system of needs and a civil society administered according to law do not contain within themselves the resources that would allow them to be "), _c('i', [_vm._v("absolutely")]), _vm._v(" self-regulated, as in the liberal dream of a pure market society. Unlike liberals, Hegel is convinced that it is necessary for the state to regulate—that is, intervene in—the economic and social sphere:")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "bqs"
  }, [_vm._v("The differing interests . . . may come into collision with each other, and even if, "), _c('i', [_vm._v("on the whole")]), _vm._v(", their correct relationship re-establishes itself automatically, its adjustment also needs to be consciously regulated by an agency which stands above both sides."), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn237",
      "id": "fn237r"
    }
  }, [_vm._v("107")])])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("The need for the state to correct the negative effects of the spontaneous workings of the system of needs through good policing (within certain limits that we must take into account, just as we must not forget that the term "), _c('i', [_vm._v("police")]), _vm._v(" had a much broader meaning in the administrative language of Hegel’s time than it does today"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn238",
      "id": "fn238r"
    }
  }, [_vm._v("108")]), _vm._v(") demonstrates the limits of a purely formal (economic and legal) actualization of the universal in a social world that would be doomed to perish in the frozen waters of egotistical calculation (as Marx would say) if there were not above it a real, "), _c('i', [_vm._v("political")]), _vm._v(" actualization of that universal. I have said that for Hegel, there is no freedom against the law—but nor can freedom be acquired by law alone, for there can be no formal surpassing of formalism.")]), _vm._v(" "), _c('h2', {
    staticClass: "ah",
    attrs: {
      "id": "ah0205"
    }
  }, [_vm._v("Private Law, Social Conflict, and Political “Union”")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("We must now turn to the question of the relationship between the state and the law in the narrow sense of abstract/private law. At first glance, Hegel’s texts seem to suggest an ambiguous, if not contradictory, relationship:")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "bqs"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "p43"
    }
  }), _vm._v("In relation to the spheres of civil law and private welfare, the spheres of the family and civil society, the state is on the one hand an "), _c('i', [_vm._v("external")]), _vm._v(" necessity and a higher power to whose nature their laws and interests are subordinate and on which they depend. But on the other hand, it is their "), _c('i', [_vm._v("immanent")]), _vm._v(" end, and its strength consists in the unity of its universal and ultimate end with the particular interest of individuals, in the fact that they have "), _c('i', [_vm._v("duties")]), _vm._v(" towards the state to the same extent as they also have rights."), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn239",
      "id": "fn239r"
    }
  }, [_vm._v("109")])])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("If this is not mere rhetoric, how are we to understand the declared reciprocity between individuals’ rights and their obligations to the state (obligations that imply a relativization of individuals’ rights) once we know that this reciprocity is characteristic of the sphere of ethicality and thereby goes beyond the double formalism of abstract (legal) right and abstract (moral) obligation? How can the task of the state be to “make "), _c('i', [_vm._v("law")]), _vm._v(" a necessary actuality”—a strong claim—if the state must at the same time bring the law—and along with it the private property that individuals aim for in exercising their rights—“into the life of the universal substance,” which may “curtail these subordinate spheres?”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn240",
      "id": "fn240r"
    }
  }, [_vm._v("110")]), _vm._v(" In other words, how can the affirmation of the autonomy of abstract law be reconciled with the relativization of abstract law by a more concrete authority, and in what way is that authority more concrete? The key to the problem, or paradox, lies in what I have called the stratification of law. Once it has been asserted that everything that contributes to the objectivization of freedom is part of the law in the broad sense, each successive figure of this objectivization is both verified and relativized by the figures that follow it:")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "bqs"
  }, [_vm._v("Each stage in the development of the idea of freedom has its distinctive right, because it is the existence of freedom in one of its own determinations. . . . They can come into "), _c('i', [_vm._v("collision")]), _vm._v(" only in so far as they are all in equal measure rights. . . . But a collision also contains this further moment: it imposes a limitation whereby one stage is subordinated to another."), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn241",
      "id": "fn241r"
    }
  }, [_vm._v("111")])])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("This is not only the case in the relationship between the state and law. For example, obeying the moral norm might require violating strict law. Unlike "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p44"
    }
  }), _vm._v("Kant, for whom, “there could be no necessity that would make what is wrong conform with law,”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn242",
      "id": "fn242r"
    }
  }, [_vm._v("112")]), _vm._v(" but like Fichte,"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn243",
      "id": "fn243r"
    }
  }, [_vm._v("113")]), _vm._v(" Hegel—reviving a certain theological tradition—recognizes the existence of a right of necessity or distress ("), _c('i', [_vm._v("jus necessitatis")]), _vm._v(", "), _c('i', [_vm._v("Notrecht")]), _vm._v("), which allows for the possibility of a violation of that which nevertheless lies at the very base of private law: the moral point of view that makes it necessary to affirm the "), _c('i', [_vm._v("legal")]), _vm._v(" superiority of life—the deprivation of which is an “infinite violation” of personhood—over property, which is merely the “particular” trace of the person:")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "bqs"
  }, [_c('i', [_vm._v("In extreme danger")]), _vm._v(" and in collision with the legal property of someone else, this life may claim (not in equity but as a right) a "), _c('i', [_vm._v("right of necessity")]), _vm._v("; for the alternatives are an infinite injury to existence with total loss of rights, and an injury only to an individual and limited existence of freedom."), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn244",
      "id": "fn244r"
    }
  }, [_vm._v("114")])])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("However, Hegel does not grant individuals an absolute right to life, and even less does he make the preservation of life the foundation of the whole legal system. Indeed, to give unlimited value to the principle of individual self-preservation would imply that the state itself must be subject to this principle, which would amount to making it a mere tool in the service of “life, liberty, and property” and would thus deprive it of its own ethical dignity. This kind of Lockean understanding of the relation between the state and life—which in a certain sense is also Hobbesian—rests on a confusion between the state and civil society and would, in the name of law, lead to the ruin of law’s own political condition of actuality. If the ultimate end of the state institution were to protect the life and property of individuals, then it could not possibly legitimately require individuals to sacrifice life or property to it and would in this way abandon its essential predicate, sovereignty:")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "bqs"
  }, [_vm._v("It is a grave miscalculation if the state, when it requires this sacrifice [of life], is simply equated with civil society, and if its ultimate end is seen merely as the "), _c('i', [_vm._v("security of the life and property")]), _vm._v(" of individuals. For this security cannot be achieved by the sacrifice of what is supposed to be "), _c('i', [_vm._v("secured")]), _vm._v("—on the contrary."), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn245",
      "id": "fn245r"
    }
  }, [_vm._v("115")])])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "p45"
    }
  }), _vm._v("Military service, war, and taxes are in principle only acceptable if the state is recognized as having a “higher nature”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn246",
      "id": "fn246r"
    }
  }, [_vm._v("116")]), _vm._v(" with respect to its citizen-subjects and to particular social interests, and thus, there is a supremacy over abstract law that proclaims the inviolability of person and property. In short, it is the very concept of objective spirit, or law in the broad sense, that justifies in its principle the theory of a legal (political) limitation of subjective rights, a theory that breaks with the individualist perspective of modern natural law according to which any restriction of rights can be justified only by the requirement to safeguard natural subjective rights.")]), _vm._v(" "), _c('p', [_vm._v("However, Hegel does not only seek to establish the state’s superiority over abstract law: the mission of the state is also to work to realize this law that reaches its limit in the state, to “make law a necessary actuality.” The point here is not the trivial one that the state plays a role in administering civil and penal justice. Moreover, as we have seen, it is fundamentally the role of civil society itself to manage the law, though it does so under government control and via the intermediary of state functionaries."), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn247",
      "id": "fn247r"
    }
  }, [_vm._v("117")]), _vm._v(" If the state is the condition of the actuality of the law and rights, this is not because it oversees the application of norms that exist by themselves. Hegel’s point is rather to show that the state’s intervention in the field of abstract law is required by the very conditions of the social actualization of abstract law. Indeed, civil society actualizes abstract law, but this actualization is conflictual to the point of endangering the very existence of a society that in certain respects recalls the state of nature as Hobbes understood it, and this conflict threatens the legal order itself. The risk is inherent in the way social life constitutes the universal in and through the clash of individual and particular interests. In an overt allusion to Hobbes’s "), _c('i', [_vm._v("bellum omnium contra omnes")]), _vm._v(", Hegel writes that civil society is “the field of conflict in which the private interest of each individual comes up against that of everyone else.”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn248",
      "id": "fn248r"
    }
  }, [_vm._v("118")]), _vm._v(" For this reason, social conflict cannot be resolved socially. Here is not the place to present this aspect of the doctrine of civil society, which is quite well known thanks to Marx’s use and development of it. But the conclusion of this doctrine gives us an answer to the questions I have raised "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p46"
    }
  }), _vm._v("here: the structurally conflictual nature of the actualization of abstract law in bourgeois civil society establishes the need for a political authority outside of social particularity that can infringe on legal principles in order to ensure their actual, effective validity. The best example of this doctrine can be found in infringements on private property by a public power. This was a burning issue in the nineteenth century, when the requirements of legal security expressed by the problematic of the "), _c('i', [_vm._v("Rechtstaat")]), _vm._v(" intersected with imperatives linked to administrative organization and to the state’s participation in economic and social transformations. Strictly speaking, such infringements are violations of private law and property, but they become legitimate when the implementation of the general principles of the law—personal freedom, the right of each individual to property and enterprise—risks being impeded by the particular assertion of certain rights or interests. Thus, the state may have to expropriate in the name of public utility or take control over certain activities (e.g., public services or even business in situations of monopoly) when the actual exercise of individual rights—and consequently the very existence of a civil society based on free enterprise—are compromised:")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "bqs"
  }, [_vm._v("[But those] determinations which concern private property may have to be subordinated to higher spheres of law, such as a community or the state. . . . Nevertheless, such exceptions cannot be grounded in contingency, private arbitrariness, or private utility, but only in the rational organism of the state."), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn249",
      "id": "fn249r"
    }
  }, [_vm._v("119")])])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("The state’s supremacy over law and rights is a result of the fact that it is impossible for the law to be spontaneously and coherently actualized in real civil society. The "), _c('i', [_vm._v("social")]), _vm._v(" actualization of the formal, legal universal is endangered by the particular material interests with which it must come into contact in order to be realized; it must therefore be reinforced by a "), _c('i', [_vm._v("political")]), _vm._v(" actualization.")]), _vm._v(" "), _c('p', [_vm._v("The state—at least, the rational, postrevolutionary, constitutional state—is present in civil society in multiple forms because of the latter’s structural inability to conform to its own principle and the tendency of the “system of atomism”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn250",
      "id": "fn250r"
    }
  }, [_vm._v("120")]), _vm._v(" to endanger the atoms themselves—that is, social individuals insofar"), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p47"
    }
  }), _vm._v(" as they are “bourgeois” rather than “citizens.”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn251",
      "id": "fn251r"
    }
  }, [_vm._v("121")]), _vm._v(" Thus, contrary to the liberal view, the state is the condition of actualization of civil society itself rather than an appendix to it or the manager of its dysfunctions. The state has a social mission: to ensure that the universal exerts its influence over the particular. But its proper, political mission is to promote the unity of the particular and the universal "), _c('i', [_vm._v("within the element of universality")]), _vm._v(". Just as the state encourages the flourishing of individuals and the always-particular (social) exercise of their rights, it must also lead individuals back “"), _c('i', [_vm._v("to substantial unity")]), _vm._v("” and subordinate them to “the interest of the universal.”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn252",
      "id": "fn252r"
    }
  }, [_vm._v("122")]), _vm._v(" Initially, it is only the state (along with the philosopher) that knows that the state is also the “immanent end” of particular interests."), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn253",
      "id": "fn253r"
    }
  }, [_vm._v("123")]), _vm._v(" Consequently, if it is true that “freedom enters into its highest right” in the state, “an absolute and unmoved end in itself,”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn254",
      "id": "fn254r"
    }
  }, [_vm._v("124")]), _vm._v(" then the right in question can no longer be identified with the right that jurists speak of. Thus, the actualization of formal law—first social, then political—culminates in a relativization of its principle: realizing its content (individual freedom) means going beyond what Hegel calls “law in a form that is lawful.”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn255",
      "id": "fn255r"
    }
  }, [_vm._v("125")]), _vm._v(" Of course, the state is not the negation of law—or rather, of the "), _c('i', [_vm._v("rights")]), _vm._v(" of individuals and social groups—but is on the contrary the ultimate condition of its actuality. But this task is far from exhausting its concept, and Hegel constantly works to denounce the error that consists in making the state a mere guarantor of the operations of private law and the night watchman of civil society.")]), _vm._v(" "), _c('p', [_vm._v("It is necessary to rigorously separate the spheres and modes of action of abstract/private law from those of the state in order to prevent the risk of weakening the political fabric (as in the case of feudalism and the "), _c('i', [_vm._v("Ständestaat")]), _vm._v(", blighted by the “privatization” of political relations) as well as the risk of politics taking on the attributes of law and ignoring its own limits (which can lead to a reign of terror). Hence, the specific nature of the political bond as well as the articulation of civil society and the state requires the political relativization of abstract law, but this relativization corresponds to precise conditions. Though Hegel does contest the ideology of the rights of man because it cloaks "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p48"
    }
  }), _vm._v("an absolute politics that seems dangerous to him, he does consider personal freedom and the legal forms that express it to be the intangible core of “eternal human rights.”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn256",
      "id": "fn256r"
    }
  }, [_vm._v("126")]), _vm._v(" Consequently, a temporary infringement of property may be necessary to save the principle of personal freedom, but in order not to destroy that very principle in the process, the infringement must not be made solely in the name of legal values that are more or less arbitrarily invoked against positive law. If the state can, without contradiction, be the guarantor of the legal order while also committing violations of its principles, this is precisely because it itself is not a construction that arises from abstract law. Thus, the goal of refusing to give the state a legal underpinning is not only to distinguish between public and private law; it is also to authorize the state, understood as the political realization of objective freedom, to be the "), _c('i', [_vm._v("external")]), _vm._v(", fully legitimate guarantor of the law and its actualizations. What might at first glance appear to be an ambiguous or contradictory position—the state must simultaneously promote and relativize (and thus contradict) the law—is in fact the expression of a coherent theoretical choice: it is because the essence of the state is not legal and because its “right” is a higher form of freedom than private law that it is able to see to it that private law is actualized in civil society.")]), _vm._v(" "), _c('p', [_vm._v("But this is only the case if the state conforms to its concept, if it truly is the institutionalization of a community of individuals whose “destiny” is, thanks to the state, to “lead a universal life”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn257",
      "id": "fn257r"
    }
  }, [_vm._v("127")]), _vm._v(" rather than a machine subjecting individuals to an arbitrary and oppressive law. The goal of the distinction between state and civil society is not to oppose the rights of the latter to the former but rather to constantly affirm that which connects “the external state”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn258",
      "id": "fn258r"
    }
  }, [_vm._v("128")]), _vm._v("—in truth it is first external to itself—to the “rational life of self-conscious freedom”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn259",
      "id": "fn259r"
    }
  }, [_vm._v("129")]), _vm._v(" as it unfolds in the public space. The state, says Hegel, is “"), _c('i', [_vm._v("union")]), _vm._v(" as such”;"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn260",
      "id": "fn260r"
    }
  }, [_vm._v("130")]), _vm._v(" it unites a city that everything else condemns to division and conflicts of interests, especially after the distinction between the political and the social has been made. Moreover, this inevitable conflict enriches a community that lives on its differences and tensions if it is overcome otherwise than through violence (in which case civil society would truly become "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p49"
    }
  }), _vm._v("the state of nature whose trace it preserves). The path to achieving this enrichment is open when there exists a state in the emphatic sense, an instance of the universal on which the affirmation of particularity in its relative right depends but which has become concretely actual through this instance. For Hegel, the state’s supremacy is the condition of law’s actuality, for there is no individual freedom that is not supported and circumscribed by a freedom that is combined with the universal.")]), _vm._v(" "), _c('h2', {
    staticClass: "ah",
    attrs: {
      "id": "ah0206"
    }
  }, [_vm._v("Law below and beyond Law")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("The arena in which the law is actualized—that is, where law’s abstract concept becomes concretely objective—is civil society, the full development of which is itself only possible within and under the hegemony of the rational state. Thus, the full actualization of the law is very recent. We know that for Hegel, the French Revolution represents the explosive and terrible ascent of law and rights as such to the rank of principle of the social and political order:")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "bqs"
  }, [_vm._v("The conception, the idea of Law asserted its authority "), _c('i', [_vm._v("all at once")]), _vm._v(", and the old framework of injustice could offer no resistance to its onslaught. A constitution, therefore, was established in harmony with the idea of Law, and on this foundation all future legislation was to be based."), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn261",
      "id": "fn261r"
    }
  }, [_vm._v("131")])])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("The corruption of this principle (e.g., the Terror) does not result from its abstraction, which in itself is neither good nor bad, but rather from the attempt to make it the foundation of a state. That attempt is the concrete culmination of the theoretical errors of natural law doctrines: the very structure of that kind of reasoning, the full consequences of which Rousseau developed, could not but encourage the project of razing the existing state of things and undertaking the refounding of the state on purely rational bases, at least in the sense of reason as mere understanding ("), _c('i', [_vm._v("Verstand")]), _vm._v(")."), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn262",
      "id": "fn262r"
    }
  }, [_vm._v("132")]), _vm._v(" On the other hand, the historical achievement of the Revolution was to have encouraged and even imposed the institution of an order of private law and the development of a civil, bourgeois society, which translates the relative but real positivity of the legal "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p50"
    }
  }), _vm._v("principle of social abstraction. The articulation of law, economy, and politics that Hegel presents in the "), _c('i', [_vm._v("Philosophy of Right")]), _vm._v(" can only have actuality in the postrevolutionary world. I will retain just one point from this analysis of the French Revolution as a revolution of the law (and rights): the actualization of law, which in itself is essentially nonhistorical, maintains a noncontingent relation with history, the actualizing act of reason in its totality. The actualization of abstract law is an integral part of the universal process by which Spirit reaches its concrete truth. But what about law at the margins of world history?")]), _vm._v(" "), _c('p', [_vm._v("For Hegel, there is no history other than political and state history. Strictly speaking, what happened before the appearance of the city must be considered prehistoric. That situation corresponds to what is traditionally called a "), _c('i', [_vm._v("state of nature")]), _vm._v(", though this term has most often been understood erroneously, or more precisely, fictively. But the term does designate—inadequately, no doubt—a situation that must be considered: it is a fiction, but a necessary fiction, one that constitutes “the crudest contradiction.”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn263",
      "id": "fn263r"
    }
  }, [_vm._v("133")]), _vm._v(" The state of nature according to Hobbes, who “takes this state [of nature] in its true sense,”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn264",
      "id": "fn264r"
    }
  }, [_vm._v("134")]), _vm._v(" is a “state governed entirely by force,” against which “the Idea sets up a "), _c('i', [_vm._v("right of heroes")]), _vm._v(".”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn265",
      "id": "fn265r"
    }
  }, [_vm._v("135")]), _vm._v(" We know how important the figure of Theseus was in the young Hegel’s political writings,"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn266",
      "id": "fn266r"
    }
  }, [_vm._v("136")]), _vm._v(" but the figure of the mythical city’s founder also appears in his mature work, where it plays a key role. The hero is the one who through violence brings an end to the violence of the state of nature. His right—which in truth is proclaimed by no one but himself and in the language of force alone—is based solely on that which it brings to an end, and the only legitimacy that can be retroactively recognized in the hero is to have factually opened the space of history and political reason. Such right is prelegal, because it is exercised before “the actual beginning of history,”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn267",
      "id": "fn267r"
    }
  }, [_vm._v("137")]), _vm._v(" whereas all true right is part of a historical process of institutionalization; such right is even "), _c('i', [_vm._v("anti")]), _vm._v("legal, because although violence can be and actually is “the external beginning” or the “beginning as it appears” of law, it cannot constitute its “substantial principle” "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p51"
    }
  }), _vm._v("or “foundation.”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn268",
      "id": "fn268r"
    }
  }, [_vm._v("138")]), _vm._v(" In certain respects, the right of heroes is an absolute right: it symbolically designates the original decision that ensures passage from the state of nature to the legal and political order. This mythological representation replaces the idea of social contract, which Hegel explicitly rejects on the grounds that it generates theoretical illusions"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn269",
      "id": "fn269r"
    }
  }, [_vm._v("139")]), _vm._v("; and in effect, this representation has the twofold advantage first of not reducing public law to private law even implicitly and second of avoiding the normativist fiction of a closed, self-founding legal order. But the mythical figure of the hero also takes on the role of Plato’s lawgiver: with this figure, Hegel consciously chooses to link the originary act with that which precedes it—the blind violence of the war of all against all—and not with what comes after it—the history and objective development of ethical and legal rationality. The first negation of nonright, the “right” of heroes remains on the side of nonright or violence. It is absolute, but it is not a right, because, like the master’s right over the slave or the conqueror’s over the conquered, it is exercised within a milieu that, compared to “the "), _c('i', [_vm._v("concept")]), _vm._v(" of the human being as spirit,” is “absolutely contrary to right.”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn270",
      "id": "fn270r"
    }
  }, [_vm._v("140")])]), _vm._v(" "), _c('p', [_vm._v("There is nothing coincidental about the similarity between the “right” of heroes and the master’s power over the slave. Like the master’s power, the hero’s is a "), _c('i', [_vm._v("Herrenschaft")]), _vm._v(", a brutal domination, rather than a "), _c('i', [_vm._v("Herrschaft")]), _vm._v(", a legitimate subordination:")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "bqs"
  }, [_vm._v("The alleged justification of "), _c('i', [_vm._v("slavery")]), _vm._v(" . . . as well as the justification of the "), _c('i', [_vm._v("master’s status")]), _vm._v(" as simple lordship in general . . . depend on regarding the human being simply as a "), _c('i', [_vm._v("natural being")]), _vm._v(" whose "), _c('i', [_vm._v("concrete existence")]), _vm._v(" ["), _c('i', [_vm._v("Existenz")]), _vm._v("] . . . is not in conformity with his concept."), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn271",
      "id": "fn271r"
    }
  }, [_vm._v("141")])])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("Discussing the figure of “lordship and bondage” from the "), _c('i', [_vm._v("Phenomenology of Spirit")]), _vm._v(", Hegel indicates that it involves the “relationship of lordship ["), _c('i', [_vm._v("Herrenschaft")]), _vm._v("] and servitude ["), _c('i', [_vm._v("Knechtschaft")]), _vm._v("].”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn272",
      "id": "fn272r"
    }
  }, [_vm._v("142")]), _vm._v(" Similarly, at the beginning of the lectures on history, he says, regarding the creation of the state, “during this first phase in its evolution, the state is imperious ["), _c('i', [_vm._v("herrisch")]), _vm._v("] and ruled by instinct.”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn273",
      "id": "fn273r"
    }
  }, [_vm._v("143")]), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p52"
    }
  }), _vm._v("It thus seems clear that in Hegel’s mature writings, the term "), _c('i', [_vm._v("Herrschaft")]), _vm._v(", distinguished from "), _c('i', [_vm._v("Herrenschaft")]), _vm._v(", refers exclusively to the specifically political act of governing ("), _c('i', [_vm._v("herrschen")]), _vm._v(" in the sense of “to govern”) and not to any prepolitical form of brute dominance. This is demonstrated a contrario by what Napoleon, one of the few modern heroes, said to the Germans he had defeated: “I am not your prince, I am your master.” However, unlike the master’s “right” over the slave, which is null because it claims to be a right, the (non)right of the hero has absolute—though temporary—legitimacy because it does not invoke a right in order to institute it. In this respect, it is similar to the absolutely absolute right of the world spirit.")]), _vm._v(" "), _c('p', [_vm._v("If the right of heroes is not yet right, the right of absolute spirit lies beyond right. Hegel repeatedly says that this right of the "), _c('i', [_vm._v("Weltgeist")]), _vm._v(" is the only “absolute”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn274",
      "id": "fn274r"
    }
  }, [_vm._v("144")]), _vm._v(" right, but it is clear that this right, like the right of the hero, has only a distant relation to right in the legal sense of the term. In that case, why keep using the name "), _c('i', [_vm._v("right")]), _vm._v("? A first answer lies in the definition of "), _c('i', [_vm._v("right")]), _vm._v(" given in the "), _c('i', [_vm._v("Philosophy of Right")]), _vm._v(", which states that “each stage in the development of the Idea of freedom has its distinctive right.”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn275",
      "id": "fn275r"
    }
  }, [_vm._v("145")]), _vm._v(" It is somewhat difficult, however, to apply this definition to the world spirit which, though it is the ultimate figure of objective spirit, does not in its full sense belong to that sphere, nor, consequently, does it exhibit its type of freedom, "), _c('i', [_vm._v("objective")]), _vm._v(" freedom. We may find proof of this in Hegel’s use of Schiller’s expression, “die Weltgeschichte ist das Weltgericht.”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn276",
      "id": "fn276r"
    }
  }, [_vm._v("146")]), _vm._v(" This expression, so often cited, actually contains a double meaning—and far from signaling some ambiguity of Hegel’s argument, the double meaning translates the complexity of the process of objective spirit, whose ultimate sense is created within history, while also going beyond history’s (merely) objective dimension.")]), _vm._v(" "), _c('p', [_vm._v("In the first place, the world spirit’s judgment cannot be appealed: it is always a death sentence, and it applies to each of the nations ["), _c('i', [_vm._v("Volk")]), _vm._v("] that have, in turn, been the “agents of its actualization” and “witnesses and ornaments of its splendour.”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn277",
      "id": "fn277r"
    }
  }, [_vm._v("147")]), _vm._v(" It is true that unlike the nation that “dominates” an epoch, "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p53"
    }
  }), _vm._v("“the spirits of other nations are without rights”;"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn278",
      "id": "fn278r"
    }
  }, [_vm._v("148")]), _vm._v(" but it is true, too, that every nation, once its task has been accomplished, must step aside in favor of a higher principle that first appears as “simply the negative of its own.”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn279",
      "id": "fn279r"
    }
  }, [_vm._v("149")]), _vm._v(" However depressing this process might appear at first glance, it must not be confused with “the abstract and irrational necessity of a blind fate”:"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn280",
      "id": "fn280r"
    }
  }, [_vm._v("150")]), _vm._v(" the history of the world is and remains the work of rational freedom becoming objective in history through combat with its own negativity; it is “the actualization of the universal spirit” in the successive negations of its particular figures.")]), _vm._v(" "), _c('p', [_vm._v("The figure of a tribunal here takes on a second, final meaning: the world spirit’s judgment not only refers to one of its particular, successive expressions; it is the judgment the world spirit pronounces on the totality that it is, revealing itself in this act as "), _c('i', [_vm._v("absolute")]), _vm._v(" spirit. "), _c('i', [_vm._v("Weltgericht")]), _vm._v(" in the ordinary sense of the term refers to the Last Judgment: in it, the world itself in the totality of its historical figures is judged—in other words, objective spirit, insofar as in its very concreteness it is still only the abstract form of spirit’s absolute presence to itself:")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "bqs"
  }, [_vm._v("But the thinking spirit of world history, when it sheds these limitations of the particular national spirits as well as its own worldliness, grasps its concrete universality and ascends to "), _c('i', [_vm._v("awareness of the absolute spirit")]), _vm._v(", as the eternally actual truth in which rational awareness is free for itself, and necessity, nature and history are only servants of its revelation and vessels of its honour."), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn281",
      "id": "fn281r"
    }
  }, [_vm._v("151")])])]), _vm._v(" "), _c('p', [_vm._v("Absolute spirit’s presence to itself—of which philosophy is the reflected expression—of course can only be achieved when objective spirit has arrived at its ultimate ethical-political expression, when spirit’s reconciliation with itself has “become objective” through the “rationality of right and law” and insofar as the state has been revealed as “the image and actuality of reason.”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0010#fn282",
      "id": "fn282r"
    }
  }, [_vm._v("152")]), _vm._v(" But this self-presence cannot possibly be exhausted in "), _c('i', [_vm._v("objective")]), _vm._v(" reconciliation. "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p54"
    }
  }), _vm._v("Once law has reached the end of the historical process of its realization, it is left behind once and for all along with the sphere of objective spirit in its entirety, whose backbone is composed of the various figures of the law. It is indicative of the system’s speculative ambition that the ultimate and absolute realization of law is strictly speaking no longer of the order of law and that full freedom is no longer "), _c('i', [_vm._v("objective")]), _vm._v(" freedom but rather is reflected in itself as freedom of the concept: as the act of philosophizing. This is perhaps why our own epoch—if it is indeed the epoch of “postmetaphysical thought”—must necessarily find it difficult to endorse a philosophy ordered around the “relativization” of right, law, and politics through “metaphysical” speculation.")]), _vm._v(" "), _c('h2', {
    staticClass: "ah"
  }, [_vm._v("Footnotes")]), _vm._v(" "), _c('div', {
    staticClass: "notes"
  }, [_c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn131r",
      "id": "fn131"
    }
  }, [_vm._v("1")]), _vm._v(". Jacques d’Hondt, “La personne et le droit abstrait selon Hegel,” in "), _c('i', [_vm._v("Droit et liberté selon Hegel")]), _vm._v(", ed. Guy Planty-Bonjour (Paris: Presses Universitaires France, 1986).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn132r",
      "id": "fn132"
    }
  }, [_vm._v("2")]), _vm._v(". "), _c('i', [_vm._v("Enzykl")]), _vm._v(", § 486, "), _c('i', [_vm._v("GW")]), _vm._v(" 20, p. 479 ("), _c('i', [_vm._v("Encyclopedia")]), _vm._v(" 218).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn133r",
      "id": "fn133"
    }
  }, [_vm._v("3")]), _vm._v(". See in particular "), _c('i', [_vm._v("RPh")]), _vm._v(", "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, § 30, p. 46; § 33, p. 48; § 36, p. 52 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 59, 62, 69; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 47, 50, 55). See also "), _c('i', [_vm._v("Enzykl")]), _vm._v(", "), _c('i', [_vm._v("GW")]), _vm._v(" 20, § 486, p. 479; § 487, p. 481; § 529, p. 501.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn134r",
      "id": "fn134"
    }
  }, [_vm._v("4")]), _vm._v(". See "), _c('i', [_vm._v("PhG")]), _vm._v(", "), _c('i', [_vm._v("GW")]), _vm._v(" 9, pp. 260–64 ("), _c('i', [_vm._v("Phenomenology")]), _vm._v(", ¶¶ 477–83). The courses on the philosophy of history describe the "), _c('i', [_vm._v("Rechtszustand")]), _vm._v(" as the “complete absence of law and right” ("), _c('i', [_vm._v("vollendete Rechtslosigkeit")]), _vm._v("). See "), _c('i', [_vm._v("Geschichte")]), _vm._v(", "), _c('i', [_vm._v("W")]), _vm._v(" 12, p. 387.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn135r",
      "id": "fn135"
    }
  }, [_vm._v("5")]), _vm._v(". Kant considers this maxim to be “a bit emphatic, but true.” See "), _c('i', [_vm._v("Frieden")]), _vm._v(", "), _c('i', [_vm._v("Ak.")]), _vm._v(" 8, p. 379; "), _c('i', [_vm._v("PP")]), _vm._v(", p. 345. Hegel, in his early writings on the constitution of the German "), _c('i', [_vm._v("Reich")]), _vm._v(" transforms it ironically into “"), _c('i', [_vm._v("fiat justitia, pereat Germania!")]), _vm._v("” Hegel, "), _c('i', [_vm._v("W")]), _vm._v(" 1, p. 470; "), _c('i', [_vm._v("Hegel’s Political Writings")]), _vm._v(", trans. Lawrence Dickey and Hugh Bar Nisbet (Oxford: Oxford University Press, 1964), 151.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn136r",
      "id": "fn136"
    }
  }, [_vm._v("6")]), _vm._v(". See "), _c('i', [_vm._v("Enzykl")]), _vm._v(" 1817, § 399, "), _c('i', [_vm._v("GW")]), _vm._v(" 13, p. 223 ("), _c('i', [_vm._v("Encyclopedia")]), _vm._v(" 1817, 240). The preference for this term instead of that of "), _c('i', [_vm._v("natural law")]), _vm._v(" is justified by the lectures of 1817–1818: “The term ‘natural right’ or ‘natural law’ ["), _c('i', [_vm._v("Naturrecht")]), _vm._v("] ought to be abandoned and replaced by the term ‘philosophical doctrine of law’ ["), _c('i', [_vm._v("philosophische Rechtslehre")]), _vm._v("], or (as will also emerge) ‘doctrine of objective spirit.’” G. W. F Hegel, "), _c('i', [_vm._v("Vorlesungen über Naturrecht und Staatswissenschaft (Heidelberg 1817/18)")]), _vm._v(" (Hambourg: Meiner, 1983), 6; "), _c('i', [_vm._v("Hegel: Lectures on Natural Right and Political Science: The First Philosophy of Right")]), _vm._v(", trans. Michael J. Stewart and Peter C. Hodgson (Oxford: Oxford University Press, 2012), § 2A, p. 52.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn137r",
      "id": "fn137"
    }
  }, [_vm._v("7")]), _vm._v(". "), _c('i', [_vm._v("RPh")]), _vm._v(", § 272 Zusatz, "), _c('i', [_vm._v("W")]), _vm._v(" 7, p. 434 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 307; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 258). See "), _c('i', [_vm._v("Die Vernunft in der Geschichte")]), _vm._v(", 1:12; "), _c('i', [_vm._v("Lectures on the Philosophy of World History")]), _vm._v(", 95: “The divine principle in the state is the Idea made manifest on earth.”")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn138r",
      "id": "fn138"
    }
  }, [_vm._v("8")]), _vm._v(". "), _c('i', [_vm._v("RPh")]), _vm._v(", § 30 Anmerkung, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, p. 46 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 59; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 47).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn139r",
      "id": "fn139"
    }
  }, [_vm._v("9")]), _vm._v(". "), _c('i', [_vm._v("RPh")]), _vm._v(", § 126 Anmerkung, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, p. 112 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 154; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 124).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn140r",
      "id": "fn140"
    }
  }, [_vm._v("10")]), _vm._v(". Kant, "), _c('i', [_vm._v("Frieden")]), _vm._v(", "), _c('i', [_vm._v("Ak.")]), _vm._v(" 8, p. 386; "), _c('i', [_vm._v("PP")]), _vm._v(", p. 351. Beginning with his early writing on the German constitution, Hegel opposes Kantian legalism, where he sees a disturbing moralism; he attacks the “philanthropists and moralists” who “decry politics as a struggle and a device for seeking one’s own advantage at the expense of the law, as a system and work of injustice.” Hegel, "), _c('i', [_vm._v("W")]), _vm._v(", 1:504; "), _c('i', [_vm._v("Hegel’s Political Writings")]), _vm._v(", 209. The condemnation of legalism is equally strong in the mature texts: see "), _c('i', [_vm._v("RPh")]), _vm._v(", § 333 Anmerkung and §337 Anmerkung, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, pp. 270, 271–72 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 368, 370; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 313, 314).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn141r",
      "id": "fn141"
    }
  }, [_vm._v("11")]), _vm._v(". Two typical examples, which have had a lasting influence on the perception of Hegelianism are, in Germany, Haym, "), _c('i', [_vm._v("Hegel und seine Zeit")]), _vm._v(", and in France, Charles Andler, "), _c('i', [_vm._v("Les origines du socialisme d’état en Allemagne")]), _vm._v(" (Paris: Alcan, 1897).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn142r",
      "id": "fn142"
    }
  }, [_vm._v("12")]), _vm._v(". See in particular Bourgeois, "), _c('i', [_vm._v("La pensée politique de Hegel")]), _vm._v("; d’Hondt, “La personne et le droit abstrait selon Hegel.”; Franz Rosenzweig, "), _c('i', [_vm._v("Hegel und der Staat (1920)")]), _vm._v(", 2 vols. (Aalen: Scientia, 1962); Eric Weil, "), _c('i', [_vm._v("Hegel et l’état")]), _vm._v(" (Paris: Vrin, 1994); Domenico Losurdo, "), _c('i', [_vm._v("Hegel und das deutsche Erbe")]), _vm._v(" (Cologne: Pahl-Rugenstein, 1989); "), _c('i', [_vm._v("Hegel e la libertà dei moderni")]), _vm._v(" (Rome: Editori Riuniti, 1992); Joachim Ritter, “Hegel und die französische Revolution,” in "), _c('i', [_vm._v("Metaphysik und Politik")]), _vm._v(" (Frankfurt am Main: Suhrkamp, 2003).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn143r",
      "id": "fn143"
    }
  }, [_vm._v("13")]), _vm._v(". Ernst Cassirer, "), _c('i', [_vm._v("The Myth of the State")]), _vm._v(" (Oxford: Oxford University Press, 1946), 248 f. Cassirer refuses to see Hegel as simply a precursor to totalitarianism, although he does claim that “no other philosophical system has done so much for the preparation of fascism and imperialism” (273).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn144r",
      "id": "fn144"
    }
  }, [_vm._v("14")]), _vm._v(". An example of "), _c('i', [_vm._v("strong")]), _vm._v(" antilegalism can be found in Carl Schmitt, who makes the sovereign political decision the founding moment of the law. See Carl Schmitt, "), _c('i', [_vm._v("Political Theology")]), _vm._v(", trans. Joseph W. Bendersky (Chicago: University of Chicago Press, 2005), 10, 13, 30–32; "), _c('i', [_vm._v("Politische Theologie")]), _vm._v(", trans. Joseph W. Bendersky (Berlin: Duncker und Humblot, 1990), 16, 19–20, 41–43. Strong antilegalism can also be found in the young Hegel, whose “The German Constitution” was a point of reference for Schmitt.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn145r",
      "id": "fn145"
    }
  }, [_vm._v("15")]), _vm._v(". "), _c('i', [_vm._v("RPh")]), _vm._v(", § 30, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, p. 46 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 59, modified; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 47).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn146r",
      "id": "fn146"
    }
  }, [_vm._v("16")]), _vm._v(". "), _c('i', [_vm._v("RPh")]), _vm._v(", § 1, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, p. 23 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 25; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 17).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn147r",
      "id": "fn147"
    }
  }, [_vm._v("17")]), _vm._v(". See, for example, "), _c('i', [_vm._v("WdL")]), _vm._v(" 3, "), _c('i', [_vm._v("GW")]), _vm._v(" 12, p. 29 ("), _c('i', [_vm._v("Science of Logic")]), _vm._v(", 526): “This is now the concept itself of the concept, but "), _c('i', [_vm._v("at first only")]), _vm._v(" the concept of the concept or also itself "), _c('i', [_vm._v("only")]), _vm._v(" concept.”")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn148r",
      "id": "fn148"
    }
  }, [_vm._v("18")]), _vm._v(". "), _c('i', [_vm._v("WdL")]), _vm._v(" 3, "), _c('i', [_vm._v("GW")]), _vm._v(" 12, p. 30 ("), _c('i', [_vm._v("Science of Logic")]), _vm._v(", 527).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn149r",
      "id": "fn149"
    }
  }, [_vm._v("19")]), _vm._v(". "), _c('i', [_vm._v("Enzykl")]), _vm._v(", § 162 Anmerkung, "), _c('i', [_vm._v("GW")]), _vm._v(" 20, p. 178 ("), _c('i', [_vm._v("Encyclopedia")]), _vm._v(" 132).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn150r",
      "id": "fn150"
    }
  }, [_vm._v("20")]), _vm._v(". "), _c('i', [_vm._v("WdL")]), _vm._v(" 3, "), _c('i', [_vm._v("GW")]), _vm._v(" 12, p. 30 ("), _c('i', [_vm._v("Science of Logic")]), _vm._v(", 527).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn151r",
      "id": "fn151"
    }
  }, [_vm._v("21")]), _vm._v(". "), _c('i', [_vm._v("WdL")]), _vm._v(" 3, "), _c('i', [_vm._v("GW")]), _vm._v(" 12, p. 130 ("), _c('i', [_vm._v("Science of Logic")]), _vm._v(", 628).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn152r",
      "id": "fn152"
    }
  }, [_vm._v("22")]), _vm._v(". "), _c('i', [_vm._v("WdL")]), _vm._v(" 3, "), _c('i', [_vm._v("GW")]), _vm._v(" 12, p. 176 ("), _c('i', [_vm._v("Science of Logic")]), _vm._v(", 673). See also "), _c('i', [_vm._v("Enzykl")]), _vm._v(" 1817, § 111, "), _c('i', [_vm._v("GW")]), _vm._v(" 13, p. 73 ("), _c('i', [_vm._v("Encyclopedia")]), _vm._v(" 1817, 102) and "), _c('i', [_vm._v("Enzykl")]), _vm._v(", § 162, "), _c('i', [_vm._v("GW")]), _vm._v(" 20, p. 177. This designation is borrowed from Schelling, who uses it both in the "), _c('i', [_vm._v("System of Transcendental Idealism")]), _vm._v(" (1800) and in the "), _c('i', [_vm._v("Presentation of My System of Philosophy")]), _vm._v(" (1801); it already existed in Fichte, in the "), _c('i', [_vm._v("Attempt at a New Presentation of the")]), _vm._v(" Wissenschaftslehre (1797) in "), _c('i', [_vm._v("Werke")]), _vm._v(" 6.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn153r",
      "id": "fn153"
    }
  }, [_vm._v("23")]), _vm._v(". “The Idea is essentially "), _c('i', [_vm._v("process")]), _vm._v(", because its identity is only the absolute and free identity of the Concept, because this identity is the absolute negativity” ("), _c('i', [_vm._v("Enzykl")]), _vm._v(", § 215, "), _c('i', [_vm._v("GW")]), _vm._v(" 20, p. 218 ["), _c('i', [_vm._v("Encyclopedia")]), _vm._v(" 290]).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn154r",
      "id": "fn154"
    }
  }, [_vm._v("24")]), _vm._v(". "), _c('i', [_vm._v("WdL")]), _vm._v(" 3, "), _c('i', [_vm._v("GW")]), _vm._v(" 12, p. 173 ("), _c('i', [_vm._v("Science of Logic")]), _vm._v(", 670).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn155r",
      "id": "fn155"
    }
  }, [_vm._v("25")]), _vm._v(". "), _c('i', [_vm._v("WdL")]), _vm._v(" 3, "), _c('i', [_vm._v("GW")]), _vm._v(" 12, p. 176 ("), _c('i', [_vm._v("Science of Logic")]), _vm._v(", 674).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn156r",
      "id": "fn156"
    }
  }, [_vm._v("26")]), _vm._v(". "), _c('i', [_vm._v("WdL")]), _vm._v(" 3, "), _c('i', [_vm._v("GW")]), _vm._v(" 12, p. 176 ("), _c('i', [_vm._v("Science of Logic")]), _vm._v(", 674).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn157r",
      "id": "fn157"
    }
  }, [_vm._v("27")]), _vm._v(". "), _c('i', [_vm._v("Enzykl")]), _vm._v(", § 214 Anmerkung, "), _c('i', [_vm._v("GW")]), _vm._v(" 20, pp. 216–18 ("), _c('i', [_vm._v("Encyclopedia")]), _vm._v(" 288–90).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn158r",
      "id": "fn158"
    }
  }, [_vm._v("28")]), _vm._v(". "), _c('i', [_vm._v("Enzykl")]), _vm._v(", § 95 Anmerkung, "), _c('i', [_vm._v("GW")]), _vm._v(" 20, p. 134 ("), _c('i', [_vm._v("Encyclopedia")]), _vm._v(" 152).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn159r",
      "id": "fn159"
    }
  }, [_vm._v("29")]), _vm._v(". "), _c('i', [_vm._v("Enzykl")]), _vm._v(", § 6, "), _c('i', [_vm._v("GW")]), _vm._v(" 20, p. 44 ("), _c('i', [_vm._v("Encyclopedia")]), _vm._v(" 29). See the prologue above.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn160r",
      "id": "fn160"
    }
  }, [_vm._v("30")]), _vm._v(". "), _c('i', [_vm._v("RPh")]), _vm._v(", § 2, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, p. 23 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 26, modified; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 18).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn161r",
      "id": "fn161"
    }
  }, [_vm._v("31")]), _vm._v(". "), _c('i', [_vm._v("RPh")]), _vm._v(", § 29, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, p. 45 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 58; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 46).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn162r",
      "id": "fn162"
    }
  }, [_vm._v("32")]), _vm._v(". When Hegel says of the science of law that it is “a part of philosophy” ("), _c('i', [_vm._v("RPh")]), _vm._v(", § 2, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, p. 23 ["), _c('i', [_vm._v("Elements")]), _vm._v(", 26; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 18]), he is not speaking of positive legal science but rather of “philosophical law,” i.e., natural-rational law. However, he refuses to abstractly oppose rational and positive law to one another as natural law does: see "), _c('i', [_vm._v("RPh")]), _vm._v(", § 3 Anmerkung, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, pp. 25–26 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 29; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 20) and "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chikervegan0011#ch02"
    }
  }, [_vm._v("chap. 2")]), _vm._v(" below.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn163r",
      "id": "fn163"
    }
  }, [_vm._v("33")]), _vm._v(". The ultimate subdivision of this (§§ 481–82 in the 3rd ed.) is titled “free spirit.” In the previous two editions, both sections appeared early in the doctrine of objective spirit (§§ 401–2 and 482–83, respectively), proof, if any were needed, of the essential continuity between subjective spirit and objective spirit within “finite spirit” ("), _c('i', [_vm._v("Enzykl")]), _vm._v(", § 386, "), _c('i', [_vm._v("GW")]), _vm._v(" 20, p. 383 ["), _c('i', [_vm._v("Encyclopedia")]), _vm._v(" 22]).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn164r",
      "id": "fn164"
    }
  }, [_vm._v("34")]), _vm._v(". See "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chikervegan0009#pt01pre"
    }
  }, [_vm._v("preliminary to part 1")]), _vm._v(" above.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn165r",
      "id": "fn165"
    }
  }, [_vm._v("35")]), _vm._v(". "), _c('i', [_vm._v("Enzykl")]), _vm._v(", § 386, "), _c('i', [_vm._v("GW")]), _vm._v(" 20, p. 384 ("), _c('i', [_vm._v("Encyclopedia")]), _vm._v(" 20).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn166r",
      "id": "fn166"
    }
  }, [_vm._v("36")]), _vm._v(". “Spirit, higher than nature.” Hegel, "), _c('i', [_vm._v("Die Vernunft in der Geschichte")]), _vm._v(", 50, margin note.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn167r",
      "id": "fn167"
    }
  }, [_vm._v("37")]), _vm._v(". "), _c('i', [_vm._v("RPh")]), _vm._v(", § 4, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, p. 31 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 35, modified; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 26). It is essential to Hegel to posit the "), _c('i', [_vm._v("equivalence")]), _vm._v(" of the concepts of will and freedom and thus not to make freedom a mere "), _c('i', [_vm._v("attribute")]), _vm._v(" of the will. See "), _c('i', [_vm._v("RPh")]), _vm._v(", § 21, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, p. 41 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 52; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 41).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn168r",
      "id": "fn168"
    }
  }, [_vm._v("38")]), _vm._v(". The specific nature of the determinations of objective spirit is that they are both concepts and shapes ("), _c('i', [_vm._v("Gestaltungen")]), _vm._v(") historically realized “in the form of existence ["), _c('i', [_vm._v("Dasein")]), _vm._v("].” See "), _c('i', [_vm._v("RPh")]), _vm._v(", § 32, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, p. 85 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 60; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 49).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn169r",
      "id": "fn169"
    }
  }, [_vm._v("39")]), _vm._v(". "), _c('i', [_vm._v("Enzykl")]), _vm._v(", § 482 Anmerkung, "), _c('i', [_vm._v("GW")]), _vm._v(" 20, p. 477 ("), _c('i', [_vm._v("Encyclopedia")]), _vm._v(" 215).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn170r",
      "id": "fn170"
    }
  }, [_vm._v("40")]), _vm._v(". See "), _c('i', [_vm._v("Enzykl")]), _vm._v(", § 484, "), _c('i', [_vm._v("GW")]), _vm._v(" 20, p. 478 ("), _c('i', [_vm._v("Encyclopedia")]), _vm._v(" 217).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn171r",
      "id": "fn171"
    }
  }, [_vm._v("41")]), _vm._v(". "), _c('i', [_vm._v("Enzykl")]), _vm._v(", § 382 Zusatz, "), _c('i', [_vm._v("GW")]), _vm._v(" 10, p. 26 ("), _c('i', [_vm._v("Encyclopedia")]), _vm._v(" 16). Hegel adds that spirit “has the power to preserve itself in contradiction, and therefore, in pain.”")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn172r",
      "id": "fn172"
    }
  }, [_vm._v("42")]), _vm._v(". Hegel distinguishes “morality” ("), _c('i', [_vm._v("Moralität")]), _vm._v(") from “ethicality” ("), _c('i', [_vm._v("Sittlichkeit")]), _vm._v("); "), _c('i', [_vm._v("RPh")]), _vm._v(", § 33 Anmerkung, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, p. 49 ["), _c('i', [_vm._v("Elements")]), _vm._v(", 63; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 51). Before him, common and philosophical language had more or less conflated the two. The distinction is explained by Hegel’s insistence on the objectivization of freedom, which only ethicality fully honors.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn173r",
      "id": "fn173"
    }
  }, [_vm._v("43")]), _vm._v(". "), _c('i', [_vm._v("Enzykl")]), _vm._v(", § 513, "), _c('i', [_vm._v("GW")]), _vm._v(" 20, p. 318 ("), _c('i', [_vm._v("Encyclopedia")]), _vm._v(" 228).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn174r",
      "id": "fn174"
    }
  }, [_vm._v("44")]), _vm._v(". See below, "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chikervegan0024#pt04pre"
    }
  }, [_vm._v("preliminary to part 4")]), _vm._v(".")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn175r",
      "id": "fn175"
    }
  }, [_vm._v("45")]), _vm._v(". "), _c('i', [_vm._v("PhG")]), _vm._v(", "), _c('i', [_vm._v("GW")]), _vm._v(" 9, p. 195; ("), _c('i', [_vm._v("Phenomenology")]), _vm._v(", ¶ 351).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn176r",
      "id": "fn176"
    }
  }, [_vm._v("46")]), _vm._v(". See Vincent Descombes, "), _c('i', [_vm._v("The Institutions of Meaning")]), _vm._v(" (Cambridge: Harvard University Press, 2014).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn177r",
      "id": "fn177"
    }
  }, [_vm._v("47")]), _vm._v(". "), _c('i', [_vm._v("RPh")]), _vm._v(", § 33, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, p. 48 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 62; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 50).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn178r",
      "id": "fn178"
    }
  }, [_vm._v("48")]), _vm._v(". "), _c('i', [_vm._v("Enzykl")]), _vm._v(", § 486, "), _c('i', [_vm._v("GW")]), _vm._v(" 20, p. 479 ("), _c('i', [_vm._v("Encyclopedia")]), _vm._v(" 218).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn179r",
      "id": "fn179"
    }
  }, [_vm._v("49")]), _vm._v(". "), _c('i', [_vm._v("RPh")]), _vm._v(", § 29, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, p. 45 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 58; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 46).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn180r",
      "id": "fn180"
    }
  }, [_vm._v("50")]), _vm._v(". "), _c('i', [_vm._v("RPh")]), _vm._v(", § 33, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, p. 48 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 62; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 50).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn181r",
      "id": "fn181"
    }
  }, [_vm._v("51")]), _vm._v(". "), _c('i', [_vm._v("RPh")]), _vm._v(", § 30 Anmerkung, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, p. 46 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 59; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 48).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn182r",
      "id": "fn182"
    }
  }, [_vm._v("52")]), _vm._v(". One of the great nineteenth-century representatives of this movement stated that “the legal order can no more be lacunar than the order of nature” (Paul Laband, quoted by Carl Bergbohm, "), _c('i', [_vm._v("Jurisprudenz und Rechtsphilosophie")]), _vm._v(" (Leipzig: Duncker und Humboldt, 1892), 73.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn183r",
      "id": "fn183"
    }
  }, [_vm._v("53")]), _vm._v(". For Kelsen, the purpose of the theory of the basic norm is to provide a theoretical basis for the positivist thesis of the closure of the normative order: “All norms whose validity can be traced back to one and the same basic norm constitute a system of norms, a normative order. . . . It is the basic norm that constitutes the unity in the multitude of norms by representing the reason for the validity of all norms that belong to this order.” Kelsen, "), _c('i', [_vm._v("Pure Theory of Law")]), _vm._v(", p. 195.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn184r",
      "id": "fn184"
    }
  }, [_vm._v("54")]), _vm._v(". "), _c('i', [_vm._v("RPh")]), _vm._v(", § 30 Anmerkung, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, p. 46 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 59; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 47).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn185r",
      "id": "fn185"
    }
  }, [_vm._v("55")]), _vm._v(". “Law is something "), _c('i', [_vm._v("utterly sacred")]), _vm._v(", for the simple reason that it is the existence ["), _c('i', [_vm._v("Dasein")]), _vm._v("] of the absolute concept, of self-conscious freedom.—But the "), _c('i', [_vm._v("formalism")]), _vm._v(" of law . . . arises out of the different stages in the development of the concept of freedom.” "), _c('i', [_vm._v("RPh")]), _vm._v(", § 30, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, p. 46 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 59; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 47).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn186r",
      "id": "fn186"
    }
  }, [_vm._v("56")]), _vm._v(". "), _c('i', [_vm._v("RPh")]), _vm._v(", § 217, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, p. 181 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 249; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 206).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn187r",
      "id": "fn187"
    }
  }, [_vm._v("57")]), _vm._v(". "), _c('i', [_vm._v("RPh")]), _vm._v(", § 217 Anmerkung, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, p. 181 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 249; "), _c('i', [_vm._v("Outlines")]), _vm._v(", 206).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn188r",
      "id": "fn188"
    }
  }, [_vm._v("58")]), _vm._v(". “Therefore there be some rights, which no man can be understood by any words, or other signs, to have abandoned, or transferred.” Thomas Hobbes, "), _c('i', [_vm._v("Leviathan")]), _vm._v(", 3 vols. (Oxford: Clarendon Press, 2012), 2:202.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn189r",
      "id": "fn189"
    }
  }, [_vm._v("59")]), _vm._v(". The social contract involves “the total alienation of each associate with all his rights to the whole community.” Jean-Jacques Rousseau, "), _c('i', [_vm._v("Oeuvres complètes")]), _vm._v(" (Paris: Gallimard, 1995), 3:360; "), _c('i', [_vm._v("The Social Contract and the First and Second Discourses")]), _vm._v(", trans. Susan Dunn and Gita May (New Haven, CT: Yale University Press, 2002), 1:6, 163 ("), _c('i', [_vm._v("Social Contract")]), _vm._v(" citations give book and chapter followed by modern translation page number). To this we must add, against the suspicion of “totalitarianism” that weighs on Rousseau, that alienation in fact corresponds only to a "), _c('i', [_vm._v("conversion")]), _vm._v(" of natural law into statutory law guaranteed by the political community: “instead of an abdication, they have made an advantageous exchange . . . of natural independence against freedom.” "), _c('i', [_vm._v("Oeuvres complètes")]), _vm._v(", 3:375; "), _c('i', [_vm._v("Social Contract")]), _vm._v(", 2:4, 176.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn190r",
      "id": "fn190"
    }
  }, [_vm._v("60")]), _vm._v(". Kant, "), _c('i', [_vm._v("Rechtslehre: MdS")]), _vm._v(", pt. 1, Einleitung, § C, "), _c('i', [_vm._v("AA")]), _vm._v(" VI, p. 230; "), _c('i', [_vm._v("PP")]), _vm._v(", p. 386.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn191r",
      "id": "fn191"
    }
  }, [_vm._v("61")]), _vm._v(". "), _c('i', [_vm._v("RPh")]), _vm._v(", § 29 Anmerkung, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, p. 45 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 58; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 47). Rousseau and Kant are both discussed here, which shows that Hegel’s critique is a "), _c('i', [_vm._v("theory")]), _vm._v(" of law, not a political conception.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn192r",
      "id": "fn192"
    }
  }, [_vm._v("62")]), _vm._v(". Recall that the German word "), _c('i', [_vm._v("Willkür")]), _vm._v(" can either mean arbitrariness (free choice) in the philosophical sense of the term or the arbitrariness that results from arbitrary misuse of it. On this point, see also the translator’s note.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn193r",
      "id": "fn193"
    }
  }, [_vm._v("63")]), _vm._v(". Compare "), _c('i', [_vm._v("MdS")]), _vm._v(", Einleitung, "), _c('i', [_vm._v("Ak.")]), _vm._v(" 6, p. 226; "), _c('i', [_vm._v("PP")]), _vm._v(", p. 380, and "), _c('i', [_vm._v("RPh")]), _vm._v(", § 15, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, p. 38 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 48; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 37).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn194r",
      "id": "fn194"
    }
  }, [_vm._v("64")]), _vm._v(". See "), _c('i', [_vm._v("RPh")]), _vm._v(", § 15 Anmerkung, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, pp. 38–39 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 48; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 38).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn195r",
      "id": "fn195"
    }
  }, [_vm._v("65")]), _vm._v(". "), _c('i', [_vm._v("Enzykl")]), _vm._v(", § 502 Anmerkung, "), _c('i', [_vm._v("GW")]), _vm._v(" 20, p. 488 ("), _c('i', [_vm._v("Encyclopedia")]), _vm._v(" 223).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn196r",
      "id": "fn196"
    }
  }, [_vm._v("66")]), _vm._v(". "), _c('i', [_vm._v("RPh")]), _vm._v(", § 35, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, p. 51 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 67–68;. see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 53–54).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn197r",
      "id": "fn197"
    }
  }, [_vm._v("67")]), _vm._v(". "), _c('i', [_vm._v("Enzykl")]), _vm._v(", § 481, "), _c('i', [_vm._v("GW")]), _vm._v(" 20, p. 476 ("), _c('i', [_vm._v("Encyclopedia")]), _vm._v(" 214). See "), _c('i', [_vm._v("RPh")]), _vm._v(", § 27, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, p. 45 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 57; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 46): “The abstract concept of the Idea of the will is in general "), _c('i', [_vm._v("the free will which wills the free will")]), _vm._v(".”")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn198r",
      "id": "fn198"
    }
  }, [_vm._v("68")]), _vm._v(". "), _c('i', [_vm._v("RPh")]), _vm._v(", margin note to § 104, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.2, p. 557.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn199r",
      "id": "fn199"
    }
  }, [_vm._v("69")]), _vm._v(". "), _c('i', [_vm._v("RPh")]), _vm._v(", § 258 Anmerkung, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, p. 203 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 277; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 230). See "), _c('i', [_vm._v("RPh")]), _vm._v(", § 13 Anmerkung, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, p. 37, and § 26, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, p. 44 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 47, 55; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 36, 44).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn200r",
      "id": "fn200"
    }
  }, [_vm._v("70")]), _vm._v(". "), _c('i', [_vm._v("RPh")]), _vm._v(", § 41, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, p. 55 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 73; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 57–58).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn201r",
      "id": "fn201"
    }
  }, [_vm._v("71")]), _vm._v(". "), _c('i', [_vm._v("RPh")]), _vm._v(", § 52 Anmerkung, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, p. 61 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 82; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 65). § 44 notes an “absolute "), _c('i', [_vm._v("right for appropriation")]), _vm._v(" . . . over all things.” "), _c('i', [_vm._v("RPh")]), _vm._v(", § 44, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, p. 57 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 75; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 85). “Man is the master of all things in nature,” notes Hegel in the margin of § 39 ("), _c('i', [_vm._v("GW")]), _vm._v(" 14.2, p. 391). Compare this with the Hobbesian state of nature as the war of each against all. See Thomas Hobbes, "), _c('i', [_vm._v("De Cive: English Version")]), _vm._v(" (Oxford: Oxford University Press, 1983), 1:10, 95–96 ("), _c('i', [_vm._v("De Cive")]), _vm._v(" citations give book and chapter followed by modern translation page number); "), _c('i', [_vm._v("Leviathan")]), _vm._v(", 2:198.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn202r",
      "id": "fn202"
    }
  }, [_vm._v("72")]), _vm._v(". "), _c('i', [_vm._v("RPh")]), _vm._v(", § 36, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, p. 52 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 69; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 55).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn203r",
      "id": "fn203"
    }
  }, [_vm._v("73")]), _vm._v(". "), _c('i', [_vm._v("RPh")]), _vm._v(", § 40 Anmerkung, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, pp. 53–54 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 71; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 56).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn204r",
      "id": "fn204"
    }
  }, [_vm._v("74")]), _vm._v(". “Through my taking possession of it, the thing ["), _c('i', [_vm._v("Sache")]), _vm._v("] acquires the predicate of being "), _c('i', [_vm._v("mine")]), _vm._v(", and the will has a "), _c('i', [_vm._v("positive")]), _vm._v(" relationship ["), _c('i', [_vm._v("Beziehung")]), _vm._v("] to it.” "), _c('i', [_vm._v("RPh")]), _vm._v(", § 59, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, p. 66 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 88; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 71).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn205r",
      "id": "fn205"
    }
  }, [_vm._v("75")]), _vm._v(". "), _c('i', [_vm._v("RPh")]), _vm._v(", § 57, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, p. 64 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 86; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 69).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn206r",
      "id": "fn206"
    }
  }, [_vm._v("76")]), _vm._v(". "), _c('i', [_vm._v("RPh")]), _vm._v(", § 57 Anmerkung, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, pp. 64–65 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 87, modified; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 70).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn207r",
      "id": "fn207"
    }
  }, [_vm._v("77")]), _vm._v(". "), _c('i', [_vm._v("Enzykl")]), _vm._v(", § 393 Zusatz, "), _c('i', [_vm._v("W")]), _vm._v(" 10, p. 57 ("), _c('i', [_vm._v("Encyclopedia")]), _vm._v(" 40).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn208r",
      "id": "fn208"
    }
  }, [_vm._v("78")]), _vm._v(". I will not address here the broad issue of Hegel’s relationship with Historical School of Law and its leader, Savigny (see "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chikervegan0011#ch02"
    }
  }, [_vm._v("chap. 2")]), _vm._v("), but it is clear that the reconstruction of abstract law, especially the treatment of the relationship between possession and property, is in good part directed against his views. The work of his disciple Eduard Gans confirms the fundamental disagreement that exists on this point between historicism and the Hegelian standpoint (Eduard Gans, "), _c('i', [_vm._v("Das erbrecht in weltgeschichtlicher Entwickelung")]), _vm._v(", 4 vols. [Berlin, 1824–1835]). We know that relatively early on Hegel read Savigny’s "), _c('i', [_vm._v("Das Recht Besitzes")]), _vm._v(" (1803; repr., Goldbach, Keip., 1997), of which he owned a copy, and that he consulted his "), _c('i', [_vm._v("History of Roman Law in the Middle Ages")]), _vm._v("; he was certainly aware of his programmatic or “policy” writings to which the "), _c('i', [_vm._v("Philosophy of Right")]), _vm._v(" alludes repeatedly (§ 3 Anmerkung, § 45, § 211 Anmerkung, § 218 Anmerkung ("), _c('i', [_vm._v("Elements")]), _vm._v(", 29, 76, 241–42, 250–51; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 21, 61, 199, 207).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn209r",
      "id": "fn209"
    }
  }, [_vm._v("79")]), _vm._v(". "), _c('i', [_vm._v("RPh")]), _vm._v(", marg. § 40, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.2, p. 395—see the margin note: “property is what traverses [the development].”")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn210r",
      "id": "fn210"
    }
  }, [_vm._v("80")]), _vm._v(". "), _c('i', [_vm._v("RPh")]), _vm._v(", § 40 Anmerkung, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, p. 54 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 71; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 56).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn211r",
      "id": "fn211"
    }
  }, [_vm._v("81")]), _vm._v(". "), _c('i', [_vm._v("RPh")]), _vm._v(", § 40 Anmerkung, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, p. 54 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 71; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 57).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn212r",
      "id": "fn212"
    }
  }, [_vm._v("82")]), _vm._v(". "), _c('i', [_vm._v("RPh")]), _vm._v(", § 40 Anmerkung, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, p. 54 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 71; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 57).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn213r",
      "id": "fn213"
    }
  }, [_vm._v("83")]), _vm._v(". See Rosenzweig, "), _c('i', [_vm._v("Hegel und der Staat (1920)")]), _vm._v(", 107–11.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn214r",
      "id": "fn214"
    }
  }, [_vm._v("84")]), _vm._v(". "), _c('i', [_vm._v("RPh")]), _vm._v(", § 41, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, p. 55 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 73; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 58).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn215r",
      "id": "fn215"
    }
  }, [_vm._v("85")]), _vm._v(". "), _c('i', [_vm._v("Naturrecht")]), _vm._v(", "), _c('i', [_vm._v("W")]), _vm._v(" 2, p. 484 ("), _c('i', [_vm._v("Natural Law: The Scientific Ways of Treating Natural Law, Its Place in Moral Philosophy, and Its Relation to the Positive Sciences of Law")]), _vm._v(" (Philadelphia: University of Pennsylvania Press, 1975), 95.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn216r",
      "id": "fn216"
    }
  }, [_vm._v("86")]), _vm._v(". "), _c('i', [_vm._v("Enzykl")]), _vm._v(", § 502 Anmerkung, "), _c('i', [_vm._v("GW")]), _vm._v(" 20, p. 488 ("), _c('i', [_vm._v("Encyclopedia")]), _vm._v(" 223).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn217r",
      "id": "fn217"
    }
  }, [_vm._v("87")]), _vm._v(". "), _c('i', [_vm._v("RPh")]), _vm._v(", § 66 Anmerkung, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, p. 71 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 96; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 78).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn218r",
      "id": "fn218"
    }
  }, [_vm._v("88")]), _vm._v(". “The equality of abstract persons as such” must of course be distinguished from “equality in the distribution of ground or even wealth” ("), _c('i', [_vm._v("RPh")]), _vm._v(", § 49 Anmerkung, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, p. 60 ["), _c('i', [_vm._v("Elements")]), _vm._v(", 80; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 64]).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn219r",
      "id": "fn219"
    }
  }, [_vm._v("89")]), _vm._v(". "), _c('i', [_vm._v("RPh")]), _vm._v(", § 40, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, p. 53 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 70; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 56).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn220r",
      "id": "fn220"
    }
  }, [_vm._v("90")]), _vm._v(". "), _c('i', [_vm._v("RPh")]), _vm._v(", § 49 Anmerkung, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, p. 60 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 80; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 64).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn221r",
      "id": "fn221"
    }
  }, [_vm._v("91")]), _vm._v(". "), _c('i', [_vm._v("RPh")]), _vm._v(", § 124 Anmerkung, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, p. 110 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 151; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 122).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn222r",
      "id": "fn222"
    }
  }, [_vm._v("92")]), _vm._v(". Hegel, "), _c('i', [_vm._v("Die Vernunft in der Geschichte")]), _vm._v(", 115–16; "), _c('i', [_vm._v("Lectures on the Philosophy of World History")]), _vm._v(", 97. See the analogous formulations in "), _c('i', [_vm._v("RPh")]), _vm._v(", § 142, and 151, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, pp. 137, 141 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 189; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 154, 159) and "), _c('i', [_vm._v("Enzykl")]), _vm._v(", § 513, "), _c('i', [_vm._v("GW")]), _vm._v(" 20, pp. 494–95 ("), _c('i', [_vm._v("Encyclopedia")]), _vm._v(" 228).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn223r",
      "id": "fn223"
    }
  }, [_vm._v("93")]), _vm._v(". See "), _c('i', [_vm._v("RPh")]), _vm._v(", § 75 A. and 163 Anmerkung, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, pp. 78, 146 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 105–6, 203; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 85, 165).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn224r",
      "id": "fn224"
    }
  }, [_vm._v("94")]), _vm._v(". "), _c('i', [_vm._v("RPh")]), _vm._v(", § 182 Zusatz, "), _c('i', [_vm._v("W")]), _vm._v(" 7, p. 339 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 220; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 181). See also "), _c('i', [_vm._v("RPh")]), _vm._v(", § 256 Anmerkung, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, pp. 199–200 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 273–74; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 227–28), and Hegel, "), _c('i', [_vm._v("Vorlesungen über Rechtsphilosophie")]), _vm._v(", 3:565.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn225r",
      "id": "fn225"
    }
  }, [_vm._v("95")]), _vm._v(". See below, "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chikervegan0014#pt02pre"
    }
  }, [_vm._v("preliminary to part 2")]), _vm._v(".")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn226r",
      "id": "fn226"
    }
  }, [_vm._v("96")]), _vm._v(". "), _c('i', [_vm._v("Enzykl")]), _vm._v(", § 544 Anmerkung, "), _c('i', [_vm._v("GW")]), _vm._v(" 20, p. 518 ("), _c('i', [_vm._v("Encyclopedia")]), _vm._v(" 242–43).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn227r",
      "id": "fn227"
    }
  }, [_vm._v("97")]), _vm._v(". See "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chikervegan0016#ch05"
    }
  }, [_vm._v("chapter 5")]), _vm._v(" below.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn228r",
      "id": "fn228"
    }
  }, [_vm._v("98")]), _vm._v(". "), _c('i', [_vm._v("RPh")]), _vm._v(", § 184, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, p. 160 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 221; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 182).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn229r",
      "id": "fn229"
    }
  }, [_vm._v("99")]), _vm._v(". "), _c('i', [_vm._v("RPh")]), _vm._v(", § 181, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, p. 159 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 219, modified; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 180).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn230r",
      "id": "fn230"
    }
  }, [_vm._v("100")]), _vm._v(". "), _c('i', [_vm._v("RPh")]), _vm._v(", § 183, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, p. 160 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 221; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 181).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn231r",
      "id": "fn231"
    }
  }, [_vm._v("101")]), _vm._v(". "), _c('i', [_vm._v("Enzykl")]), _vm._v(", § 532, "), _c('i', [_vm._v("GW")]), _vm._v(" 20, p. 505 ("), _c('i', [_vm._v("Encyclopedia")]), _vm._v(" 235).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn232r",
      "id": "fn232"
    }
  }, [_vm._v("102")]), _vm._v(". On the transformation of natural need into social need and its liberating effects, see "), _c('i', [_vm._v("RPh")]), _vm._v(", § 194, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, p. 167 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 230; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", p. 189).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn233r",
      "id": "fn233"
    }
  }, [_vm._v("103")]), _vm._v(". "), _c('i', [_vm._v("Enzykl")]), _vm._v(", § 524, "), _c('i', [_vm._v("GW")]), _vm._v(" 20, p. 499 ("), _c('i', [_vm._v("Encyclopedia")]), _vm._v(" 230–31).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn234r",
      "id": "fn234"
    }
  }, [_vm._v("104")]), _vm._v(". See "), _c('i', [_vm._v("RPh")]), _vm._v(", § 46, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, pp. 57–58 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 77; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 61).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn235r",
      "id": "fn235"
    }
  }, [_vm._v("105")]), _vm._v(". "), _c('i', [_vm._v("RPh")]), _vm._v(", § 190 Anmerkung, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, p. 166 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 228; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 188).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn236r",
      "id": "fn236"
    }
  }, [_vm._v("106")]), _vm._v(". "), _c('i', [_vm._v("RPh")]), _vm._v(", § 200 Anmerkung, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, p. 170 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 234; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 192).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn237r",
      "id": "fn237"
    }
  }, [_vm._v("107")]), _vm._v(". "), _c('i', [_vm._v("RPh")]), _vm._v(", § 236, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, p. 190 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 261–262; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 217).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn238r",
      "id": "fn238"
    }
  }, [_vm._v("108")]), _vm._v(". On this subject see Hans Maier, "), _c('i', [_vm._v("Die ältere deutsche Staats und Verwaltungslehre")]), _vm._v(" (Munich: DTV, 1986).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn239r",
      "id": "fn239"
    }
  }, [_vm._v("109")]), _vm._v(". "), _c('i', [_vm._v("RPh")]), _vm._v(", § 261, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, p. 208 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 283; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 235–36).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn240r",
      "id": "fn240"
    }
  }, [_vm._v("110")]), _vm._v(". "), _c('i', [_vm._v("Enzykl")]), _vm._v(", § 537, "), _c('i', [_vm._v("GW")]), _vm._v(" 20, p. 508 ("), _c('i', [_vm._v("Encyclopedia")]), _vm._v(" 236).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn241r",
      "id": "fn241"
    }
  }, [_vm._v("111")]), _vm._v(". "), _c('i', [_vm._v("RPh")]), _vm._v(", § 30 Anmerkung, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, p. 46 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 59, modified; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 47–48). See also "), _c('i', [_vm._v("Enzykl")]), _vm._v(", § 380, "), _c('i', [_vm._v("GW")]), _vm._v(" 20, p. 381 ("), _c('i', [_vm._v("Encyclopedia")]), _vm._v(" 8).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn242r",
      "id": "fn242"
    }
  }, [_vm._v("112")]), _vm._v(". See the introduction to Kant, "), _c('i', [_vm._v("Rechtslehre: MdS")]), _vm._v(", Einleitung, "), _c('i', [_vm._v("Ak.")]), _vm._v(" 6, p. 236; "), _c('i', [_vm._v("PP")]), _vm._v(", p. 392.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn243r",
      "id": "fn243"
    }
  }, [_vm._v("113")]), _vm._v(". See Fichte, "), _c('i', [_vm._v("Naturrecht")]), _vm._v(", "), _c('i', [_vm._v("Werke")]), _vm._v(", 3:252.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn244r",
      "id": "fn244"
    }
  }, [_vm._v("114")]), _vm._v(". "), _c('i', [_vm._v("RPh")]), _vm._v(", § 127, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, p. 112 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 154; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 125).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn245r",
      "id": "fn245"
    }
  }, [_vm._v("115")]), _vm._v(". "), _c('i', [_vm._v("RPh")]), _vm._v(", § 324 Anmerkung, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, p. 265 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 361; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 306).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn246r",
      "id": "fn246"
    }
  }, [_vm._v("116")]), _vm._v(". "), _c('i', [_vm._v("RPh")]), _vm._v(", § 75 Anmerkung, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, p. 78 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 106; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 85), and "), _c('i', [_vm._v("RPh")]), _vm._v(", § 100 Anmerkung, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, pp. 92–93 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 126; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 191). On the justification of taxes, see "), _c('i', [_vm._v("RPh")]), _vm._v(", § 299 and Anmerkung, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, p. 247 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 337–38; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 285–86).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn247r",
      "id": "fn247"
    }
  }, [_vm._v("117")]), _vm._v(". See "), _c('i', [_vm._v("RPh")]), _vm._v(", § 287, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, p. 241 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 328–29; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 277–78).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn248r",
      "id": "fn248"
    }
  }, [_vm._v("118")]), _vm._v(". "), _c('i', [_vm._v("RPh")]), _vm._v(", § 289 Anmerkung, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, p. 241 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 329; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 278).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn249r",
      "id": "fn249"
    }
  }, [_vm._v("119")]), _vm._v(". "), _c('i', [_vm._v("RPh")]), _vm._v(", § 46 Anmerkung, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, p. 58 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 77, see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 61).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn250r",
      "id": "fn250"
    }
  }, [_vm._v("120")]), _vm._v(". "), _c('i', [_vm._v("Enzykl")]), _vm._v(", § 523, "), _c('i', [_vm._v("GW")]), _vm._v(" 20, p. 498 ("), _c('i', [_vm._v("Encyclopedia")]), _vm._v(" 230).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn251r",
      "id": "fn251"
    }
  }, [_vm._v("121")]), _vm._v(". See "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chikervegan0015#ch04"
    }
  }, [_vm._v("chapter 4")]), _vm._v(" below.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn252r",
      "id": "fn252"
    }
  }, [_vm._v("122")]), _vm._v(". "), _c('i', [_vm._v("RPh")]), _vm._v(", § 260, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, p. 208 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 282; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 235).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn253r",
      "id": "fn253"
    }
  }, [_vm._v("123")]), _vm._v(". "), _c('i', [_vm._v("RPh")]), _vm._v(", § 261, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, p. 208 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 283; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 236).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn254r",
      "id": "fn254"
    }
  }, [_vm._v("124")]), _vm._v(". "), _c('i', [_vm._v("RPh")]), _vm._v(", § 258, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, p. 201 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 275; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 228).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn255r",
      "id": "fn255"
    }
  }, [_vm._v("125")]), _vm._v(". "), _c('i', [_vm._v("RPh")]), _vm._v(", § 220, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, p. 183 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 252, modified; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 209).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn256r",
      "id": "fn256"
    }
  }, [_vm._v("126")]), _vm._v(". "), _c('i', [_vm._v("Enzykl")]), _vm._v(", § 433 Zusatz, "), _c('i', [_vm._v("W")]), _vm._v(" 10, p. 224 ("), _c('i', [_vm._v("Encyclopedia")]), _vm._v(" 160).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn257r",
      "id": "fn257"
    }
  }, [_vm._v("127")]), _vm._v(". "), _c('i', [_vm._v("RPh")]), _vm._v(", § 258 Anmerkung, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, pp. 201–2 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 275; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 229).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn258r",
      "id": "fn258"
    }
  }, [_vm._v("128")]), _vm._v(". "), _c('i', [_vm._v("RPh")]), _vm._v(", "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, § 157, 183, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, pp. 143, 160 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 198, 221; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 162, 181); "), _c('i', [_vm._v("Enzykl")]), _vm._v(", § 523, "), _c('i', [_vm._v("GW")]), _vm._v(" 20, p. 498 ("), _c('i', [_vm._v("Encyclopedia")]), _vm._v(" 230).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn259r",
      "id": "fn259"
    }
  }, [_vm._v("129")]), _vm._v(". "), _c('i', [_vm._v("RPh")]), _vm._v(", § 270 Anmerkung, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, p. 218 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 297; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 248).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn260r",
      "id": "fn260"
    }
  }, [_vm._v("130")]), _vm._v(". "), _c('i', [_vm._v("RPh")]), _vm._v(", § 258 Anmerkung, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, p. 213 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 276; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 229).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn261r",
      "id": "fn261"
    }
  }, [_vm._v("131")]), _vm._v(". "), _c('i', [_vm._v("Geschichte")]), _vm._v(", "), _c('i', [_vm._v("W")]), _vm._v(" 12, p. 529 / 466 (modified). See also "), _c('i', [_vm._v("Wurtemberg")]), _vm._v(", "), _c('i', [_vm._v("W")]), _vm._v(" 4, p. 507; "), _c('i', [_vm._v("Proceedings")]), _vm._v(", in "), _c('i', [_vm._v("Hegel’s Political Writings")]), _vm._v(", 282.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn262r",
      "id": "fn262"
    }
  }, [_vm._v("132")]), _vm._v(". See "), _c('i', [_vm._v("RPh")]), _vm._v(", § 258 Anmerkung, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, p. 202 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 276–77; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 229–30).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn263r",
      "id": "fn263"
    }
  }, [_vm._v("133")]), _vm._v(". "), _c('i', [_vm._v("Naturrecht")]), _vm._v(", "), _c('i', [_vm._v("W")]), _vm._v(" 2, p. 445 ("), _c('i', [_vm._v("Natural Law")]), _vm._v(", 63).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn264r",
      "id": "fn264"
    }
  }, [_vm._v("134")]), _vm._v(". "), _c('i', [_vm._v("W")]), _vm._v(" 20, p. 227.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn265r",
      "id": "fn265"
    }
  }, [_vm._v("135")]), _vm._v(". "), _c('i', [_vm._v("RPh")]), _vm._v(", § 93 Anmerkung, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, p. 88 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 120; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 98). Hegel specifies that this is “a right of heroes to establish states” ("), _c('i', [_vm._v("RPh")]), _vm._v(", § 350, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, p. 277 ["), _c('i', [_vm._v("Elements")]), _vm._v(", 376; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 319).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn266r",
      "id": "fn266"
    }
  }, [_vm._v("136")]), _vm._v(". See “Verfassung,” "), _c('i', [_vm._v("W")]), _vm._v(" 1, p. 579 (“German Constitution,” in "), _c('i', [_vm._v("Hegel’s Political Writings")]), _vm._v(", 241) and "), _c('i', [_vm._v("GW")]), _vm._v(" 8, p. 258.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn267r",
      "id": "fn267"
    }
  }, [_vm._v("137")]), _vm._v(". RPh, § 349 Anmerkung, GW 14.1, p. 277 (Elements, 375; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 318).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn268r",
      "id": "fn268"
    }
  }, [_vm._v("138")]), _vm._v(". "), _c('i', [_vm._v("Enzykl")]), _vm._v(", § 433 Anmerkung, "), _c('i', [_vm._v("GW")]), _vm._v(" 20, p. 431 ("), _c('i', [_vm._v("Encyclopedia")]), _vm._v(" 160).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn269r",
      "id": "fn269"
    }
  }, [_vm._v("139")]), _vm._v(". See "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chikervegan0012#ch03"
    }
  }, [_vm._v("chapter 3")]), _vm._v(" below.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn270r",
      "id": "fn270"
    }
  }, [_vm._v("140")]), _vm._v(". "), _c('i', [_vm._v("RPh")]), _vm._v(", § 57 Anmerkung, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, p. 65 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 86–87; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 69–70).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn271r",
      "id": "fn271"
    }
  }, [_vm._v("141")]), _vm._v(". "), _c('i', [_vm._v("RPh")]), _vm._v(", § 57 Anmerkung, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, p. 65 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 86–87; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 69–70).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn272r",
      "id": "fn272"
    }
  }, [_vm._v("142")]), _vm._v(". "), _c('i', [_vm._v("RPh")]), _vm._v(", § 57 Anmerkung, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, p. 64 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 87, modified; "), _c('i', [_vm._v("Outlines")]), _vm._v(", 70).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn273r",
      "id": "fn273"
    }
  }, [_vm._v("143")]), _vm._v(". Hegel, "), _c('i', [_vm._v("Die Vernunft in der Geschichte")]), _vm._v(", 146; "), _c('i', [_vm._v("Lectures on the Philosophy of World History")]), _vm._v(".")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn274r",
      "id": "fn274"
    }
  }, [_vm._v("144")]), _vm._v(". "), _c('i', [_vm._v("RPh")]), _vm._v(", § 30 Anmerkung, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, p. 46 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 59; see also "), _c('i', [_vm._v("Outlines")]), _vm._v(", 48). See also § 33, 340.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn275r",
      "id": "fn275"
    }
  }, [_vm._v("145")]), _vm._v(". "), _c('i', [_vm._v("RPh")]), _vm._v(", § 30 Anmerkung, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, p. 46 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 59; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 47).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn276r",
      "id": "fn276"
    }
  }, [_vm._v("146")]), _vm._v(". See "), _c('i', [_vm._v("RPh")]), _vm._v(", § 340, 342, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, pp. 272, 274 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 371–72; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 315–16) and "), _c('i', [_vm._v("Enzykl")]), _vm._v(", § 548, "), _c('i', [_vm._v("GW")]), _vm._v(" 20, p. 523 ("), _c('i', [_vm._v("Encyclopedia")]), _vm._v(" 246).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn277r",
      "id": "fn277"
    }
  }, [_vm._v("147")]), _vm._v(". "), _c('i', [_vm._v("RPh")]), _vm._v(", § 352, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, p. 278 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 376; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 319).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn278r",
      "id": "fn278"
    }
  }, [_vm._v("148")]), _vm._v(". "), _c('i', [_vm._v("RPh")]), _vm._v(", § 347, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, p. 506 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 374; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 317).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn279r",
      "id": "fn279"
    }
  }, [_vm._v("149")]), _vm._v(". "), _c('i', [_vm._v("RPh")]), _vm._v(", § 347 Anmerkung, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, p. 276 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 374; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 318).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn280r",
      "id": "fn280"
    }
  }, [_vm._v("150")]), _vm._v(". "), _c('i', [_vm._v("RPh")]), _vm._v(", § 342, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, p. 504; "), _c('i', [_vm._v("PPD")]), _vm._v(", p. 431 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 372; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 316).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn281r",
      "id": "fn281"
    }
  }, [_vm._v("151")]), _vm._v(". "), _c('i', [_vm._v("Enzykl")]), _vm._v(", § 552, "), _c('i', [_vm._v("GW")]), _vm._v(" 20, p. 530 ("), _c('i', [_vm._v("Encyclopedia")]), _vm._v(" 250).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0010#fn282r",
      "id": "fn282"
    }
  }, [_vm._v("152")]), _vm._v(". "), _c('i', [_vm._v("RPh")]), _vm._v(", § 360, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, p. 512 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 380; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 323).")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69a6d830","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-kervegan-0010.vue
// module id = 81
// module chunks = 0